export const translations = {
  it: {
    // Common
    common: {
      close: 'Chiudi',
      save: 'Salva',
      cancel: 'Annulla',
      delete: 'Elimina',
      edit: 'Modifica',
      search: 'Cerca',
      loading: 'Caricamento...',
      error: 'Errore',
      success: 'Successo',
      confirm: 'Conferma',
      back: 'Indietro',
      next: 'Avanti',
      submit: 'Invia',
      ok: 'OK',
      yes: 'Sì',
      no: 'No',
    },
    
    // Footer
    footer: {
      termsAndConditions: 'Termini e Condizioni',
      privacyPolicy: 'Privacy Policy',
      copyright: '© 2025 I.F. Core Lab - Tutti i diritti riservati',
      noReproduction: 'È vietata la riproduzione anche parziale',
    },
    
    // Cookie Banner
    cookie: {
      title: 'Utilizziamo i Cookie',
      message: 'Questo sito utilizza cookie tecnici necessari al funzionamento. Continuando la navigazione accetti l\'utilizzo dei cookie.',
      accept: 'Accetta',
      moreInfo: 'Maggiori informazioni',
    },
    
    // PWA Install Guide
    pwa: {
      title: 'Installa ServiceGo',
      subtitle: 'Aggiungi l\'app alla tua schermata home per un accesso rapido',
      androidTitle: 'Su Android',
      androidStep1: 'Tocca il menu ⋮ in alto a destra',
      androidStep2: 'Seleziona "Aggiungi a schermata Home"',
      androidStep3: 'Tocca "Aggiungi"',
      iosTitle: 'Su iPhone/iPad',
      iosStep1: 'Tocca l\'icona condivisione ⬆',
      iosStep2: 'Scorri e tocca "Aggiungi a Home"',
      iosStep3: 'Tocca "Aggiungi" in alto a destra',
      skip: 'Continua senza installare',
      dontShowAgain: 'Non mostrare più',
    },
    
    // Welcome
    welcome: {
      title: 'Benvenuti su JobConnect',
      startAsClient: 'Inizia come Cliente',
      registerCompany: 'Registra la tua Ditta',
      howItWorks: 'Come funziona?',
    },
    
    // Auth
    auth: {
      login: 'Accedi',
      logout: 'Logout',
      register: 'Registrati',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Password dimenticata?',
      noAccount: 'Non hai un account?',
      hasAccount: 'Hai già un account?',
      invalidCredentials: 'Credenziali non valide',
      loginSuccess: 'Login effettuato con successo',
      resetPassword: 'Reimposta Password',
      resetPasswordDesc: 'Inserisci la tua email per ricevere il link di reset',
      sendResetLink: 'Invia Link di Reset',
      resetEmailSent: 'Se l\'email esiste, riceverai un link per il reset',
      newPassword: 'Nuova Password',
      confirmPassword: 'Conferma Password',
      passwordUpdated: 'Password aggiornata con successo',
      invalidToken: 'Token non valido o scaduto',
      backToLogin: 'Torna al Login',
      verifyEmail: 'Verifica Email',
      verifyEmailDesc: 'Clicca il pulsante per verificare la tua email',
      emailVerified: 'Email verificata con successo',
      verificationSent: 'Email di verifica inviata',
      tooManyRequests: 'Troppe richieste, riprova più tardi',
      welcomeBack: 'Bentornato!',
      loginSubtitle: 'Accedi al tuo account per continuare',
      haveAccount: 'Hai già un account?',
    },
    
    // Navigation
    nav: {
      home: 'Home',
      dashboard: 'Dashboard',
      requests: 'Richieste',
      offers: 'Offerte',
      messages: 'Messaggi',
      chat: 'Chat',
      settings: 'Impostazioni',
      profile: 'Profilo',
      registerAsClient: 'Registrati come Cliente',
      registerAsCompany: 'Registrati come Ditta',
    },
    
    // Client Dashboard
    clientDashboard: {
      title: 'Dashboard Cliente',
      welcome: 'Benvenuto',
      myRequests: 'Le mie richieste',
      newRequest: 'Nuova Richiesta',
      offersReceived: 'Offerte ricevute',
      viewOffers: 'Vedi Offerte',
      pending: 'In attesa',
      accepted: 'Accettate',
      rejected: 'Rifiutate',
      open: 'Aperte',
      assigned: 'In corso',
      completed: 'Completate',
      cancelled: 'Annullate',
    },
    
    // Company Dashboard
    companyDashboard: {
      title: 'Dashboard Ditta',
      welcome: 'Benvenuto',
      openRequests: 'Richieste Aperte',
      offersSent: 'Offerte Inviate',
      statistics: 'Statistiche',
      monthlyRevenue: 'Fatturato mensile',
      subscription: 'Abbonamento',
      allOffersSent: 'Tutte le offerte inviate',
      viewAll: 'Vedi tutte',
    },
    
    // New Request
    newRequest: {
      title: 'Nuova Richiesta',
      selectCategory: 'Seleziona l\'artigiano di cui hai bisogno',
      requestTitle: 'Oggetto Richiesta',
      description: 'Descrizione del lavoro',
      descriptionPlaceholder: 'Descrivi dettagliatamente il lavoro da svolgere...',
      attachPhotos: 'Allega foto',
      maxPhotos: 'Max 5 foto',
      uploadPhoto: 'Carica foto',
      takePhoto: 'Scatta foto',
      address: 'Indirizzo del lavoro',
      street: 'Via',
      number: 'Numero civico',
      city: 'Città',
      district: 'Distretto',
      selectDistrict: 'Seleziona Distretto',
      cap: 'Codice Postale (CAP)',
      preferredDays: 'Preferenza giorni',
      selectDays: 'Seleziona almeno un giorno',
      preferredSlots: 'Preferenza fasce orarie',
      selectSlots: 'Seleziona almeno una fascia',
      urgent: 'Urgente',
      submitRequest: 'Invia Richiesta',
      requestPublished: 'La tua richiesta è stata pubblicata!',
      excellent: 'Benissimo!',
      // Validation
      selectCategoryError: 'Seleziona una categoria',
      titleError: 'Inserisci l\'oggetto della richiesta',
      descriptionError: 'Inserisci la descrizione del lavoro',
      capError: 'Inserisci il codice postale',
      streetError: 'Inserisci la via',
      numberError: 'Inserisci il numero civico',
      districtError: 'Seleziona il distretto',
      daysError: 'Seleziona almeno un giorno preferito',
      slotsError: 'Seleziona almeno una fascia oraria preferita',
    },
    
    // Requests
    requests: {
      myRequests: 'Le mie richieste',
      noRequests: 'Nessuna richiesta ancora.',
      requestSentOn: 'Richiesta inviata il',
      offersReceived: 'Offerte ricevute',
      urgency: 'Urgenza',
      status: 'Stato',
      deleteRequest: 'Elimina richiesta',
      confirmDelete: 'Sei sicuro di voler eliminare questa richiesta?',
      requestDeleted: 'La richiesta è stata eliminata con successo',
      perfect: 'Perfetto!',
      viewDetail: 'Vedi dettaglio',
    },
    
    // Offers
    offers: {
      offerDetail: 'Dettaglio offerta',
      totalAmount: 'Importo Totale',
      offerDetails: 'Dettagli Offerta',
      offerType: 'Tipo offerta:',
      fixedPrice: 'A corpo',
      hourly: 'A ore',
      hourlyRate: 'Tariffa oraria:',
      workers: 'N. operai:',
      estimatedHours: 'Ore stimate:',
      travelCost: 'Costo trasferta:',
      materialsCost: 'Costo materiali:',
      otherCosts: 'Altri costi:',
      workPeriod: 'Periodo lavori',
      from: 'Dal:',
      to: 'Al:',
      additionalNotes: 'Note aggiuntive',
      terms: 'Termini e condizioni',
      sentOn: 'Data invio',
      chooseCompany: 'Scegli questa ditta',
      withdrawOffer: 'Ritira offerta',
      noOffers: 'Nessuna offerta ancora.',
      sendOffer: 'Invia Offerta',
      offerSent: 'Offerta inviata con successo',
      openChat: 'Apri chat con la ditta',
    },
    
    // Messages/Chat
    messages: {
      title: 'Messaggi',
      noConversations: 'Nessuna conversazione.',
      noConversationsHint: 'Accetta un\'offerta per iniziare a chattare con una ditta!',
      searchConversations: 'Cerca conversazioni...',
      searchPlaceholder: 'Cerca...',
      writeMessage: 'Scrivi un messaggio...',
      noMessages: 'Nessun messaggio ancora. Inizia la conversazione!',
      loadingError: 'Errore nel caricamento dei messaggi',
      sendError: 'Errore nell\'invio del messaggio',
    },
    
    // Settings
    settings: {
      title: 'Impostazioni',
      subtitle: 'Gestisci i tuoi dati personali e le preferenze',
      myData: 'I miei dati',
      personalData: 'Dati Personali',
      contacts: 'Contatti',
      address: 'Indirizzo',
      preferences: 'Preferenze',
      notifications: 'Notifiche',
      receiveUpdates: 'Ricevi aggiornamenti sulle richieste',
      name: 'Nome',
      surname: 'Cognome',
      companyName: 'Ragione sociale',
      phone: 'Telefono',
      vatNumber: 'UID / Registro di Commercio',
      changePhoto: 'Cambia immagine profilo',
      saveChanges: 'Salva modifiche',
      dataUpdated: 'Dati aggiornati',
      profileImageUpdated: 'Immagine profilo aggiornata',
      invalidImage: 'Seleziona un\'immagine valida',
      imageTooLarge: 'Immagine troppo grande (max 5MB)',
      updateError: 'Errore durante l\'aggiornamento',
      termsAndConditions: 'Termini e Condizioni',
      privacyPolicy: 'Privacy Policy',
      deleteAccount: 'Elimina account',
      deleteAccountTitle: 'Elimina account',
      deleteAccountMessage: 'Facci sapere il motivo della tua scelta, siamo molto dispiaciuti e vorremmo aiutarti.',
      deleteReasonPlaceholder: 'Scrivi qui il motivo...',
      findSolution: 'Valutiamo assieme una soluzione',
      confirmDelete: 'Elimina definitivamente account',
      helpTitle: 'Hai bisogno di aiuto?',
      clientSince: 'Cliente dal',
      understood: 'Ho capito',
      language: 'Lingua',
    },
    
    // Days
    days: {
      monday: 'Lunedì',
      tuesday: 'Martedì',
      wednesday: 'Mercoledì',
      thursday: 'Giovedì',
      friday: 'Venerdì',
      saturday: 'Sabato',
      sunday: 'Domenica',
    },
    
    // Time slots
    timeSlots: {
      morning: 'Mattina (8-12)',
      afternoon: 'Pomeriggio (13-17)',
      evening: 'Sera (18-20)',
      any: 'Indifferente',
    },
    
    // Status
    status: {
      pending: 'In attesa',
      won: 'Accettata',
      lost: 'Rifiutata',
      withdrawn: 'Ritirata',
      expired: 'Scaduta',
      open: 'Aperta',
      assigned: 'In corso',
      completed: 'Completata',
      cancelled: 'Annullata',
    },

    // Register Client
    registerClient: {
      title: 'Nuovo Cliente',
      subtitle: 'Compila tutti i campi per completare la registrazione',
      personalData: 'Dati Personali',
      name: 'Nome',
      surname: 'Cognome',
      contacts: 'Contatti',
      email: 'Email',
      phone: 'Numero di telefono',
      address: 'Indirizzo',
      street: 'Via',
      number: 'Numero civico',
      cap: 'CAP',
      city: 'Località',
      password: 'Password',
      submitButton: 'Registra Cliente',
      successMessage: 'Registrazione avvenuta con successo!',
      errorMessage: 'Errore registrazione',
      register: 'Registrati',
    },

    // Register Company
    registerCompany: {
      title: 'Registrazione Ditta',
      subtitle: 'Completa i dati della tua azienda per iniziare',
      companyName: 'Nome Ditta *',
      companyNamePlaceholder: 'Es. ABC Solutions SA',
      street: 'Via *',
      streetPlaceholder: 'Via Nassa',
      number: 'Numero civico *',
      numberPlaceholder: 'Es. 42',
      postalCode: 'CAP *',
      postalCodePlaceholder: 'Es. 6900',
      city: 'Città *',
      cityPlaceholder: 'Es. Lugano',
      fullAddress: 'Indirizzo Completo *',
      fullAddressPlaceholder: 'Via, numero civico, CAP, città',
      commerceNumber: 'UID (Numero identificativo) *',
      commerceNumberPlaceholder: 'CHE-123.456.789',
      professionalType: 'Tipo di Figura Professionale *',
      professionalTypePlaceholder: 'Seleziona la professione',
      businessEmail: 'Email Aziendale *',
      businessEmailPlaceholder: 'info@azienda.ch',
      phoneNumber: 'Numero di Telefono *',
      phoneNumberPlaceholder: '+41 XX XXX XX XX',
      password: 'Password',
      subscriptionPlan: 'Piano Abbonamento',
      pricePerMonth: '/mese',
      plusContactFee: 'Chat con i clienti inclusa',
      planFeature1: 'Accesso illimitato alla piattaforma',
      planFeature2: 'Richieste concrete di lavoro',
      planFeature3: 'Supporto clienti prioritario',
      planFeature4: 'Acquisci recensioni positive e fai vedere di che pasta sei fatto!',
      subscribeButton: 'Abbonati ora!',
      successMessage: 'Registrazione ditta completata',
      errorMessage: 'Errore registrazione ditta',
      redirectToPayment: 'Reindirizzamento al pagamento...',
      paymentError: 'Errore nel reindirizzamento al pagamento',
    },

    // Bottom Navigation
    bottomNav: {
      home: 'Home',
      new: 'Nuova',
      chat: 'Chat',
      profile: 'Profilo',
      support: 'Supporto',
    },

    // How It Works
    howItWorks: {
      title: 'Come funziona?',
      forCustomers: 'Per i Clienti',
      customerStep1: 'Descrivi il lavoro',
      customerStep1Detail: ': dettagli e fino a 5 foto (gratis).',
      customerStep2: 'Ricevi fino a 3 offerte',
      customerStep2Detail: ' da ditte vicine.',
      customerStep3: 'Scegli la ditta',
      customerStep3Detail: ' che preferisci.',
      customerStep4: 'È tutto gratuito',
      customerStep4Detail: ' per te.',
      iAmCustomer: 'Diventa Cliente',
      forCompanies: 'Per le Ditte',
      companyStep1: 'Sfoglia richieste',
      companyStep1Detail: ' nella tua zona e invia un\'offerta.',
      companyStep2: 'Contatta il cliente',
      companyStep2Detail: ' quando vieni scelto: chat diretta e gratuita.',
      companyStep3: 'Abbonamento semplice',
      companyStep3Detail: ': 49 CHF/mese dopo 3 mesi gratis.',
      iAmCompany: 'Sono una Ditta',
    },

    // Company Requests / Open Requests
    companyRequests: {
      title: 'Richieste Aperte',
      filterDistrict: 'Distretto',
      allDistricts: 'Tutti i distretti',
      filterCategory: 'Categoria',
      applyFilters: 'Filtra',
      offersCount: 'offerte',
      viewButton: 'Vedi',
      sendOfferButton: 'Invia Offerta',
      noRequests: 'Nessuna richiesta aperta',
      today: 'oggi',
      day: 'giorno',
      days: 'giorni',
      week: 'settimana',
      weeks: 'settimane',
      offerDialogTitle: 'Compila l\'offerta',
      offerType: 'Tipo di offerta',
      offerTypeFixed: 'A corpo',
      offerTypeHourly: 'Ad ore',
      fixedAmount: 'Importo a corpo (EUR)',
      fixedAmountPlaceholder: 'Es. 1200',
      hourlyRate: 'Tariffa oraria (EUR/ora)',
      hourlyRatePlaceholder: 'Es. 80',
      numberOfWorkers: 'N. operai',
      workersPlaceholder: 'Es. 2',
      estimatedHours: 'Ore stimate',
      hoursPlaceholder: 'Es. 6',
      travelCost: 'Costo trasferta (EUR)',
      travelPlaceholder: 'Es. 30',
      materialsCost: 'Costo materiali (EUR)',
      materialsPlaceholder: 'Es. 100 (può essere zero)',
      otherCosts: 'Altri costi (EUR)',
      otherCostsPlaceholder: 'Es. smaltimento, ricambi...',
      attachPhotos: 'Allega foto (max 3)',
      chooseFiles: 'Scegli file',
      filesSelected: 'selezionato/i',
      availablePeriod: 'Periodo disponibile',
      fromDate: 'Dal',
      toDate: 'Al',
      notesOrDetails: 'Note o richiesta dettagli',
      notesPlaceholder: 'Scrivi eventuali domande o dettagli...',
      termsAndConditions: 'Termini e condizioni',
      termsPlaceholder: 'Specificare termini di pagamento, tempistiche, esclusioni, ecc.',
      total: 'Totale',
      send: 'Invia',
      invalidAmount: 'Importo totale non valido',
      offerSentSuccess: 'Offerta inviata correttamente ✅',
      offerSentError: 'Errore invio offerta',
      requestDetailTitle: 'Dettaglio richiesta',
      urgency: 'Urgenza',
      yes: 'Si',
      no: 'No',
      preferredDays: 'Preferenza giorni',
      timeSlots: 'Fasce orarie',
      noPreference: 'Nessuna preferenza',
    },

    // Settings
    settings: {
      title: 'Impostazioni',
      subtitle: 'Gestisci i tuoi dati personali e le preferenze',
      myData: 'I miei dati',
      name: 'Nome',
      surname: 'Cognome',
      email: 'Email',
      phone: 'Telefono',
      address: 'Indirizzo',
      street: 'Via',
      number: 'N. civico',
      cap: 'CAP',
      city: 'Città',
      cancel: 'Annulla',
      save: 'Salva',
      termsAndConditions: 'Termini e Condizioni',
      privacyPolicy: 'Privacy Policy',
      needHelp: 'Hai bisogno di aiuto?',
      deleteAccount: 'Elimina account',
      changeProfileImage: 'Cambia immagine profilo',
      clientSince: 'Cliente dal',
      companySince: 'Azienda dal',
      dataUpdated: 'Dati aggiornati',
      updateError: 'Errore durante l\'aggiornamento',
      invalidImage: 'Seleziona un\'immagine valida',
      imageTooLarge: 'Immagine troppo grande (max 5MB)',
      profileImageUpdated: 'Immagine profilo aggiornata',
      imageUpdateError: 'Errore durante l\'aggiornamento dell\'immagine',
      imageLoadError: 'Errore durante il caricamento dell\'immagine',
      deleteAccountTitle: 'Elimina account',
      deleteAccountMessage: 'Facci sapere il motivo della tua scelta, siamo molto dispiaciuti e vorremmo aiutarti.',
      deleteReasonPlaceholder: 'Scrivi qui il motivo...',
      evaluateSolution: 'Valutiamo assieme una soluzione',
      confirmDeleteAccount: 'Elimina definitivamente account',
      requestSent: 'Richiesta inviata al supporto',
      understood: 'Ho capito',
      lastUpdate: 'Ultimo aggiornamento',
    },

    // Company Settings
    companySettings: {
      companyData: 'Dati della Ditta',
      companyName: 'Ragione sociale',
      dangerWarning: 'Attenzione: questa azione è irreversibile. Tutti i tuoi dati verranno eliminati permanentemente.',
    },

    // Categories (Artisan professions)
    categories: {
      'Idraulico': 'Idraulico',
      'Elettricista': 'Elettricista',
      'Pulizie': 'Pulizie',
      'Giardinaggio': 'Giardinaggio',
      'Traslochi': 'Traslochi',
      'Falegnameria': 'Falegnameria',
      'Imbianchino/Pittore': 'Imbianchino/Pittore',
      'Pavimenti e Piastrelle': 'Pavimenti e Piastrelle',
      'Serramenti e Infissi': 'Serramenti e Infissi',
      'Fabbro': 'Fabbro',
      'Riscaldamento e Climatizzazione': 'Riscaldamento e Climatizzazione',
      'Antennista': 'Antennista',
      'Muratore/Edilizia': 'Muratore/Edilizia',
      'Cartongesso': 'Cartongesso',
      'Tetti e Coperture': 'Tetti e Coperture',
      'Isolamento Termico': 'Isolamento Termico',
      'Tapparelle e Avvolgibili': 'Tapparelle e Avvolgibili',
      'Vetrai': 'Vetrai',
      'Parquet': 'Parquet',
      'Porte e Finestre': 'Porte e Finestre',
      'Cancelli Automatici': 'Cancelli Automatici',
      'Carpenteria Metallica': 'Carpenteria Metallica',
      'Lattoniere': 'Lattoniere',
      'Spazzacamino': 'Spazzacamino',
      'Tende e Zanzariere': 'Tende e Zanzariere',
      'Manutenzione Giardini': 'Manutenzione Giardini',
      'Potature': 'Potature',
      'Allarmi e Videosorveglianza': 'Allarmi e Videosorveglianza',
      'Domotica': 'Domotica',
      'Fotovoltaico': 'Fotovoltaico',
      'Caldaie e Stufe': 'Caldaie e Stufe',
      'Pompe di Calore': 'Pompe di Calore',
      'Piscine': 'Piscine',
      'Pozzi e Trivellazioni': 'Pozzi e Trivellazioni',
      'Disinfestazione': 'Disinfestazione',
      'Sgomberi': 'Sgomberi',
      'Ristrutturazioni Complete': 'Ristrutturazioni Complete',
      'Interior Design': 'Interior Design',
      'Architetto': 'Architetto',
      'Geometra': 'Geometra',
      'Ingegnere': 'Ingegnere',
      'Consulente Energetico': 'Consulente Energetico',
      'Ascensori e Montacarichi': 'Ascensori e Montacarichi',
      'Tapezziere': 'Tapezziere',
      'Verniciatura Industriale': 'Verniciatura Industriale',
      'Lucidatura Pavimenti': 'Lucidatura Pavimenti',
      'Trattamento Marmo': 'Trattamento Marmo',
      'Impermeabilizzazioni': 'Impermeabilizzazioni',
      'Rifacimento Bagno': 'Rifacimento Bagno',
      'Rifacimento Cucina': 'Rifacimento Cucina',
      'Cabine Armadio': 'Cabine Armadio',
      'Pergole e Gazebo': 'Pergole e Gazebo',
      'Recinzioni': 'Recinzioni',
      'Sistemi di Irrigazione': 'Sistemi di Irrigazione',
      'Potatura Alberi': 'Potatura Alberi',
      'Progettazione Giardini': 'Progettazione Giardini',
    },

    // Payment
    payment: {
      verifying: 'Verifica pagamento...',
      pleaseWait: 'Attendere prego...',
      success: 'Pagamento completato!',
      successMessage: 'Il tuo abbonamento è stato attivato con successo!',
      redirecting: 'Reindirizzamento alla dashboard...',
      canceled: 'Pagamento annullato',
      canceledMessage: 'Pagamento annullato. La registrazione non è stata completata.',
      registrationCanceled: 'Registrazione annullata',
      tryAgain: 'Riprova la registrazione',
      backToHome: 'Torna alla home',
      error: 'Errore',
      errorMessage: 'Si è verificato un errore durante la verifica del pagamento.',
      processingMessage: 'Verifica pagamento in corso...',
    },

    // Subscription
    subscription: {
      title: 'Abbonamento',
      manage: 'Gestisci',
      cancelSubscription: 'Annulla abbonamento',
      activateSubscription: 'Attiva abbonamento',
      subscriptionActive: 'Abbonamento Attivo',
      subscriptionCanceled: 'Abbonamento Annullato',
      perMonth: 'al mese',
      currentMonthSummary: 'Riepilogo Mese Corrente',
      baseSubscription: 'Abbonamento base',
      unlockedContacts: 'Chat attivate',
      estimatedTotal: 'Totale stimato',
      all: 'Tutti',
      enterPassword: 'Inserisci la password',
    },

    // Dashboard
    dashboard: {
      title: 'Dashboard',
      summary: 'Riepilogo delle tue attività',
      requestsMade: 'Richieste Effettuate',
      requestsMadeSubtitle: 'Visualizza tutte le tue richieste di servizio',
      offersReceived: 'Offerte Ricevute',
      offersReceivedSubtitle: 'Controlla le offerte dei professionisti',
      reviewsMade: 'Recensioni Effettuate',
      reviewsMadeSubtitle: 'Le tue valutazioni sui servizi ricevuti',
      offersPending: 'In attesa',
      offersAccepted: 'Scelte',
      offersRejected: 'Rifiutate',
      reviewsSummary: 'Riepilogo Recensioni',
      basedOnReviews: 'Basato su {{count}} recensioni',
      currentMonthBilling: 'Fatturazione mese corrente',
      subscription: 'Abbonamento',
      contactsUnlocked: 'Contatti Sbloccati',
      seeAll: 'Vedi Tutto',
      offersSent: 'Offerte Inviate',
      viewAllOffers: 'Vedi tutte le tue offerte',
      offerStatus: 'Stato offerta',
      withdrawOffer: 'Ritira offerta',
      offerWithdrawn: 'Offerta ritirata',
      cannotWithdraw: 'Impossibile ritirare',
      company: 'Ditta',
      noReviewsYet: 'Nessuna recensione ricevuta',
    },

    // UI Common (shared across pages)
    ui: {
      usefulLinks: 'Link Utili',
      alreadyHaveAccount: 'Hai già un account?',
      login: 'Accedi',
      logout: 'Logout',
      loading: 'Caricamento...',
      manageCompanyProfile: 'Gestisci il profilo della tua ditta',
      howToBeContacted: 'Come vuoi essere contattato?',
      companiesWillContact: 'Le ditte interessate ti contatteranno direttamente su questo recapito',
      describeYourNeed: 'Descrivi di cosa hai bisogno e verrai contattato direttamente',
      requestPublished: 'La tua richiesta è stata pubblicata.',
      willBeContacted: 'Verrai contattato direttamente dalle ditte interessate.',
      whatsapp: 'WhatsApp',
      phone: 'Telefono',
      email: 'Email',
      yourEmail: 'La tua email',
      yourNumber: 'Il tuo numero (es. +41 79 123 4567)',
      enterContact: 'Inserisci un recapito per essere contattato',
      monthlyPlan: 'Piano Mensile',
      freeMonth: '3 mesi gratis',
      firstMonthFree: '3 mesi gratuiti, poi 49 CHF/mese',
      threeMonthsFree: '3 mesi gratis',
      threeMonthsFreeThen: '3 mesi gratuiti, poi 49 CHF/mese',
      companyData: 'Dati della Ditta',
      yourDataGdpr: 'I tuoi dati (GDPR)',
      downloadAllData: 'Scarica tutti i tuoi dati personali in formato JSON.',
      exportMyData: 'Esporta i miei dati',
      dataExported: 'Dati esportati con successo!',
      dataExportError: 'Errore durante l\'export dei dati',
      invoices: 'Fatture',
      allFilter: 'Tutti',
      subscriptionFilter: 'Abbonamento',
      contactFilter: 'Contatto',
      noInvoices: 'Nessuna fattura',
      invoiceWillBeGenerated: 'La fattura verrà generata automaticamente il 1° del prossimo mese',
      cancelSubscription: 'Annulla abbonamento',
      cancelConfirm: 'Sei sicuro di annullare l\'abbonamento?',
      cancel: 'Annulla',
      yesImSure: 'Si, sono sicuro',
      enterPasswordToConfirm: 'Inserisci la password per confermare.',
      back: 'Indietro',
      confirm: 'Conferma',
      offersReceived: 'Offerte ricevute',
      backToRequests: 'Torna alle richieste',
      offerDetail: 'Dettaglio Offerta',
      amount: 'Importo',
      status: 'Stato',
      pending: 'In attesa',
      accepted: 'Accettata',
      rejected: 'Rifiutata',
      type: 'Tipo:',
      fixedPrice: 'A corpo',
      hourly: 'A ore',
      price: 'Prezzo:',
      hourlyRate: 'Tariffa oraria:',
      notes: 'Note:',
      sentDate: 'Data invio',
      chooseThisCompany: 'Scegli questa ditta',
      close: 'Chiudi',
      noOffers: 'Nessuna offerta ancora.',
      waiting: 'Attesa',
      inProgress: 'In Corso',
      completed: 'Completata',
      canceled: 'Annullata',
      openChatWithCompany: 'Apri chat con la ditta',
      noCompanySelected: 'Nessuna ditta selezionata',
      companySelected: 'Ditta selezionata!',
      selectionError: 'Errore selezione',
      emailSent: 'Email Inviata!',
      requestNewLink: 'Richiedi nuovo link',
      linkExpiredOrInvalid: 'Il link potrebbe essere scaduto o non valido.',
      nowLoginWithNewPassword: 'Ora puoi accedere con la tua nuova password.',
      passwordMinLength: 'La password deve avere almeno 6 caratteri',
      passwordsDontMatch: 'Le password non coincidono',
      noBinding: 'Nessun vincolo',
      chooseCompany: 'Scegli ditta',
      subscriptionInvoice: 'Fattura Abbonamento',
      contactUnlocked: 'Contatto Sbloccato',
      // Landing page
      freeForClients: 'Gratuito per privati',
      fastReplies: 'Risposte veloci',
      directContact: 'Contatto diretto',
      unlimitedRequests: 'Pubblica richieste illimitate',
      receiveContacts: 'Ricevi contatti dalle ditte',
      zeroCommissions: 'Zero commissioni',
      accessAllRequests: 'Accesso a tutte le richieste',
      contactClientsDirectly: 'Contatta i clienti direttamente',
      // Company Requests
      allFilter2: 'Tutti',
      allCategories: 'Tutte',
      requestDetail: 'Dettaglio Richiesta',
      // Client Requests
      whoContactedYou: 'Chi ti ha contattato',
      deleteRequest: 'Elimina richiesta',
      // Admin Dashboard
      users: 'Utenti',
      requests: 'Richieste',
      transactions: 'Transazioni',
      userManagement: 'Gestione Utenti',
      recentRequests: 'Richieste Recenti',
      recentTransactions: 'Transazioni Recenti',
      changePassword: 'Cambia Password',
    },
  },
  
  de: {
    // Common
    common: {
      close: 'Schließen',
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      search: 'Suchen',
      loading: 'Laden...',
      error: 'Fehler',
      success: 'Erfolg',
      confirm: 'Bestätigen',
      back: 'Zurück',
      next: 'Weiter',
      submit: 'Absenden',
      ok: 'OK',
      yes: 'Ja',
      no: 'Nein',
    },
    
    // Footer
    footer: {
      termsAndConditions: 'Nutzungsbedingungen',
      privacyPolicy: 'Datenschutz',
      copyright: '© 2025 I.F. Core Lab - Alle Rechte vorbehalten',
      noReproduction: 'Jede Vervielfältigung ist verboten',
    },
    
    // Cookie Banner
    cookie: {
      title: 'Wir verwenden Cookies',
      message: 'Diese Website verwendet technische Cookies. Durch die weitere Nutzung akzeptieren Sie die Verwendung von Cookies.',
      accept: 'Akzeptieren',
      moreInfo: 'Mehr Informationen',
    },
    
    // PWA Install Guide
    pwa: {
      title: 'ServiceGo installieren',
      subtitle: 'Fügen Sie die App zu Ihrem Startbildschirm hinzu',
      androidTitle: 'Auf Android',
      androidStep1: 'Tippen Sie auf das Menü ⋮ oben rechts',
      androidStep2: 'Wählen Sie "Zum Startbildschirm hinzufügen"',
      androidStep3: 'Tippen Sie auf "Hinzufügen"',
      iosTitle: 'Auf iPhone/iPad',
      iosStep1: 'Tippen Sie auf das Teilen-Symbol ⬆',
      iosStep2: 'Scrollen Sie und tippen Sie auf "Zum Home-Bildschirm"',
      iosStep3: 'Tippen Sie oben rechts auf "Hinzufügen"',
      skip: 'Ohne Installation fortfahren',
      dontShowAgain: 'Nicht mehr anzeigen',
    },
    
    // Welcome
    welcome: {
      title: 'Willkommen bei JobConnect',
      startAsClient: 'Als Kunde starten',
      registerCompany: 'Registrieren Sie Ihr Unternehmen',
      howItWorks: 'Wie funktioniert es?',
    },
    
    // Auth
    auth: {
      login: 'Anmelden',
      logout: 'Abmelden',
      register: 'Registrieren',
      email: 'E-Mail',
      password: 'Passwort',
      forgotPassword: 'Passwort vergessen?',
      noAccount: 'Sie haben kein Konto?',
      hasAccount: 'Sie haben bereits ein Konto?',
      invalidCredentials: 'Ungültige Anmeldedaten',
      loginSuccess: 'Erfolgreich angemeldet',
      resetPassword: 'Passwort zurücksetzen',
      resetPasswordDesc: 'Geben Sie Ihre E-Mail-Adresse ein, um den Reset-Link zu erhalten',
      sendResetLink: 'Reset-Link senden',
      resetEmailSent: 'Falls die E-Mail existiert, erhalten Sie einen Reset-Link',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Passwort bestätigen',
      passwordUpdated: 'Passwort erfolgreich aktualisiert',
      invalidToken: 'Ungültiger oder abgelaufener Token',
      backToLogin: 'Zurück zur Anmeldung',
      verifyEmail: 'E-Mail verifizieren',
      verifyEmailDesc: 'Klicken Sie auf die Schaltfläche, um Ihre E-Mail zu verifizieren',
      emailVerified: 'E-Mail erfolgreich verifiziert',
      verificationSent: 'Bestätigungs-E-Mail gesendet',
      tooManyRequests: 'Zu viele Anfragen, bitte versuchen Sie es später erneut',
      welcomeBack: 'Willkommen zurück!',
      loginSubtitle: 'Melden Sie sich an, um fortzufahren',
      haveAccount: 'Haben Sie bereits ein Konto?',
    },
    
    // Navigation
    nav: {
      home: 'Startseite',
      dashboard: 'Dashboard',
      requests: 'Anfragen',
      offers: 'Angebote',
      messages: 'Nachrichten',
      chat: 'Chat',
      settings: 'Einstellungen',
      profile: 'Profil',
      registerAsClient: 'Als Kunde registrieren',
      registerAsCompany: 'Als Unternehmen registrieren',
    },
    
    // Client Dashboard
    clientDashboard: {
      title: 'Kunden-Dashboard',
      welcome: 'Willkommen',
      myRequests: 'Meine Anfragen',
      newRequest: 'Neue Anfrage',
      offersReceived: 'Erhaltene Angebote',
      viewOffers: 'Angebote anzeigen',
      pending: 'Ausstehend',
      accepted: 'Akzeptiert',
      rejected: 'Abgelehnt',
      open: 'Offen',
      assigned: 'In Bearbeitung',
      completed: 'Abgeschlossen',
      cancelled: 'Storniert',
    },
    
    // Company Dashboard
    companyDashboard: {
      title: 'Firmen-Dashboard',
      welcome: 'Willkommen',
      openRequests: 'Offene Anfragen',
      offersSent: 'Gesendete Angebote',
      statistics: 'Statistiken',
      monthlyRevenue: 'Monatlicher Umsatz',
      subscription: 'Abonnement',
      allOffersSent: 'Alle gesendeten Angebote',
      viewAll: 'Alle anzeigen',
    },
    
    // New Request
    newRequest: {
      title: 'Neue Anfrage',
      selectCategory: 'Wählen Sie den benötigten Handwerker',
      requestTitle: 'Anfragetitel',
      description: 'Arbeitsbeschreibung',
      descriptionPlaceholder: 'Beschreiben Sie die durchzuführende Arbeit im Detail...',
      attachPhotos: 'Fotos anhängen',
      maxPhotos: 'Max. 5 Fotos',
      uploadPhoto: 'Foto hochladen',
      takePhoto: 'Foto aufnehmen',
      address: 'Arbeitsadresse',
      street: 'Straße',
      number: 'Hausnummer',
      city: 'Stadt',
      district: 'Bezirk',
      selectDistrict: 'Bezirk auswählen',
      cap: 'Postleitzahl',
      preferredDays: 'Bevorzugte Tage',
      selectDays: 'Wählen Sie mindestens einen Tag',
      preferredSlots: 'Bevorzugte Zeitfenster',
      selectSlots: 'Wählen Sie mindestens ein Zeitfenster',
      urgent: 'Dringend',
      submitRequest: 'Anfrage senden',
      requestPublished: 'Ihre Anfrage wurde veröffentlicht!',
      excellent: 'Ausgezeichnet!',
      // Validation
      selectCategoryError: 'Wählen Sie eine Kategorie',
      titleError: 'Geben Sie den Anfragetitel ein',
      descriptionError: 'Geben Sie die Arbeitsbeschreibung ein',
      capError: 'Geben Sie die Postleitzahl ein',
      streetError: 'Geben Sie die Straße ein',
      numberError: 'Geben Sie die Hausnummer ein',
      districtError: 'Wählen Sie den Bezirk',
      daysError: 'Wählen Sie mindestens einen bevorzugten Tag',
      slotsError: 'Wählen Sie mindestens ein bevorzugtes Zeitfenster',
    },
    
    // Requests
    requests: {
      myRequests: 'Meine Anfragen',
      noRequests: 'Noch keine Anfragen.',
      requestSentOn: 'Anfrage gesendet am',
      offersReceived: 'Erhaltene Angebote',
      urgency: 'Dringlichkeit',
      status: 'Status',
      deleteRequest: 'Anfrage löschen',
      confirmDelete: 'Sind Sie sicher, dass Sie diese Anfrage löschen möchten?',
      requestDeleted: 'Die Anfrage wurde erfolgreich gelöscht',
      perfect: 'Perfekt!',
      viewDetail: 'Details anzeigen',
    },
    
    // Offers
    offers: {
      offerDetail: 'Angebotsdetails',
      totalAmount: 'Gesamtbetrag',
      offerDetails: 'Angebotsdetails',
      offerType: 'Angebotstyp:',
      fixedPrice: 'Pauschalpreis',
      hourly: 'Stundenweise',
      hourlyRate: 'Stundensatz:',
      workers: 'Anzahl Arbeiter:',
      estimatedHours: 'Geschätzte Stunden:',
      travelCost: 'Anfahrtskosten:',
      materialsCost: 'Materialkosten:',
      otherCosts: 'Sonstige Kosten:',
      workPeriod: 'Arbeitszeitraum',
      from: 'Von:',
      to: 'Bis:',
      additionalNotes: 'Zusätzliche Hinweise',
      terms: 'Geschäftsbedingungen',
      sentOn: 'Sendedatum',
      chooseCompany: 'Dieses Unternehmen wählen',
      withdrawOffer: 'Angebot zurückziehen',
      noOffers: 'Noch keine Angebote.',
      sendOffer: 'Angebot senden',
      offerSent: 'Angebot erfolgreich gesendet',
      openChat: 'Chat mit dem Unternehmen öffnen',
    },
    
    // Messages/Chat
    messages: {
      title: 'Nachrichten',
      noConversations: 'Keine Unterhaltungen.',
      noConversationsHint: 'Akzeptieren Sie ein Angebot, um mit einem Unternehmen zu chatten!',
      searchConversations: 'Unterhaltungen durchsuchen...',
      searchPlaceholder: 'Suchen...',
      writeMessage: 'Nachricht schreiben...',
      noMessages: 'Noch keine Nachrichten. Beginnen Sie die Unterhaltung!',
      loadingError: 'Fehler beim Laden der Nachrichten',
      sendError: 'Fehler beim Senden der Nachricht',
    },
    
    // Settings
    settings: {
      title: 'Einstellungen',
      subtitle: 'Verwalten Sie Ihre persönlichen Daten und Einstellungen',
      myData: 'Meine Daten',
      personalData: 'Persönliche Daten',
      contacts: 'Kontakte',
      address: 'Adresse',
      preferences: 'Einstellungen',
      notifications: 'Benachrichtigungen',
      receiveUpdates: 'Updates zu Anfragen erhalten',
      name: 'Vorname',
      surname: 'Nachname',
      companyName: 'Firmenname',
      phone: 'Telefon',
      vatNumber: 'MwSt-Nr. / UID',
      changePhoto: 'Profilbild ändern',
      saveChanges: 'Änderungen speichern',
      dataUpdated: 'Daten aktualisiert',
      profileImageUpdated: 'Profilbild aktualisiert',
      invalidImage: 'Wählen Sie ein gültiges Bild',
      imageTooLarge: 'Bild zu groß (max. 5MB)',
      updateError: 'Fehler beim Aktualisieren',
      termsAndConditions: 'Allgemeine Geschäftsbedingungen',
      privacyPolicy: 'Datenschutzrichtlinie',
      deleteAccount: 'Konto löschen',
      deleteAccountTitle: 'Konto löschen',
      deleteAccountMessage: 'Lassen Sie uns wissen, warum Sie gehen möchten. Es tut uns sehr leid und wir möchten Ihnen helfen.',
      deleteReasonPlaceholder: 'Schreiben Sie hier den Grund...',
      findSolution: 'Lassen Sie uns gemeinsam eine Lösung finden',
      confirmDelete: 'Konto endgültig löschen',
      helpTitle: 'Benötigen Sie Hilfe?',
      clientSince: 'Kunde seit',
      understood: 'Verstanden',
      language: 'Sprache',
    },
    
    // Days
    days: {
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag',
    },
    
    // Time slots
    timeSlots: {
      morning: 'Morgen (8-12)',
      afternoon: 'Nachmittag (13-17)',
      evening: 'Abend (18-20)',
      any: 'Egal',
    },
    
    // Status
    status: {
      pending: 'Ausstehend',
      won: 'Akzeptiert',
      lost: 'Abgelehnt',
      withdrawn: 'Zurückgezogen',
      expired: 'Abgelaufen',
      open: 'Offen',
      assigned: 'In Bearbeitung',
      completed: 'Abgeschlossen',
      cancelled: 'Storniert',
    },

    // Register Client
    registerClient: {
      title: 'Neuer Kunde',
      subtitle: 'Füllen Sie alle Felder aus, um die Registrierung abzuschließen',
      personalData: 'Persönliche Daten',
      name: 'Vorname',
      surname: 'Nachname',
      contacts: 'Kontakte',
      email: 'E-Mail',
      phone: 'Telefonnummer',
      address: 'Adresse',
      street: 'Straße',
      number: 'Hausnummer',
      cap: 'PLZ',
      city: 'Ort',
      password: 'Passwort',
      submitButton: 'Kunde registrieren',
      successMessage: 'Registrierung abgeschlossen',
      errorMessage: 'Registrierungsfehler',
      register: 'Registrieren',
    },

    // Register Company
    registerCompany: {
      title: 'Firmenregistrierung',
      subtitle: 'Vervollständigen Sie die Daten Ihres Unternehmens, um zu beginnen',
      companyName: 'Firmenname *',
      companyNamePlaceholder: 'z.B. ABC Solutions AG',
      street: 'Straße *',
      streetPlaceholder: 'Hauptstraße',
      number: 'Hausnummer *',
      numberPlaceholder: 'z.B. 42',
      postalCode: 'PLZ *',
      postalCodePlaceholder: 'z.B. 8000',
      city: 'Stadt *',
      cityPlaceholder: 'z.B. Zürich',
      fullAddress: 'Vollständige Adresse *',
      fullAddressPlaceholder: 'Straße, Hausnummer, PLZ, Stadt',
      commerceNumber: 'Handelsregisternummer *',
      commerceNumberPlaceholder: 'CHE-123.456.789',
      professionalType: 'Art der Berufsgruppe *',
      professionalTypePlaceholder: 'Beruf auswählen',
      businessEmail: 'Geschäftliche E-Mail *',
      businessEmailPlaceholder: 'info@firma.ch',
      phoneNumber: 'Telefonnummer *',
      phoneNumberPlaceholder: '+41 XX XXX XX XX',
      password: 'Passwort',
      subscriptionPlan: 'Abonnement-Plan',
      pricePerMonth: '/Monat',
      plusContactFee: 'Chat mit Kunden inklusive',
      planFeature1: 'Unbegrenzter Zugang zur Plattform',
      planFeature2: 'Konkrete Arbeitsanfragen',
      planFeature3: 'Vorrangiger Kundensupport',
      planFeature4: 'Sammeln Sie positive Bewertungen und zeigen Sie, was Sie können!',
      subscribeButton: 'Jetzt abonnieren!',
      successMessage: 'Firmenregistrierung abgeschlossen',
      errorMessage: 'Firmenregistrierungsfehler',
    },

    // Bottom Navigation
    bottomNav: {
      home: 'Startseite',
      new: 'Neu',
      chat: 'Chat',
      profile: 'Profil',
      support: 'Support',
    },

    // How It Works
    howItWorks: {
      title: 'Wie funktioniert es?',
      forCustomers: 'Für Kunden',
      customerStep1: 'Arbeit beschreiben',
      customerStep1Detail: ': Details und bis zu 5 Fotos (kostenlos).',
      customerStep2: 'Bis zu 3 Angebote erhalten',
      customerStep2Detail: ' von Unternehmen in der Nähe.',
      customerStep3: 'Unternehmen wählen',
      customerStep3Detail: ', das Ihnen am besten gefällt.',
      customerStep4: 'Alles ist kostenlos',
      customerStep4Detail: ' für Sie.',
      iAmCustomer: 'Ich bin Kunde',
      forCompanies: 'Für Unternehmen',
      companyStep1: 'Anfragen durchsuchen',
      companyStep1Detail: ' in Ihrer Region und ein Angebot senden.',
      companyStep2: 'Kunden kontaktieren',
      companyStep2Detail: ' wenn Sie ausgewählt werden: direkte und kostenlose Chat.',
      companyStep3: 'Einfaches Abonnement',
      companyStep3Detail: ': 49 CHF/Monat nach 3 Monaten gratis.',
      iAmCompany: 'Ich bin ein Unternehmen',
    },

    // Company Requests / Open Requests
    companyRequests: {
      title: 'Offene Anfragen',
      filterDistrict: 'Bezirk',
      allDistricts: 'Alle Bezirke',
      filterCategory: 'Kategorie',
      applyFilters: 'Filtern',
      offersCount: 'Angebote',
      viewButton: 'Ansehen',
      sendOfferButton: 'Angebot senden',
      noRequests: 'Keine offenen Anfragen',
      today: 'heute',
      day: 'Tag',
      days: 'Tage',
      week: 'Woche',
      weeks: 'Wochen',
      offerDialogTitle: 'Angebot ausfüllen',
      offerType: 'Angebotstyp',
      offerTypeFixed: 'Pauschalpreis',
      offerTypeHourly: 'Stundensatz',
      fixedAmount: 'Pauschalbetrag (EUR)',
      fixedAmountPlaceholder: 'z.B. 1200',
      hourlyRate: 'Stundensatz (EUR/Stunde)',
      hourlyRatePlaceholder: 'z.B. 80',
      numberOfWorkers: 'Anzahl Arbeiter',
      workersPlaceholder: 'z.B. 2',
      estimatedHours: 'Geschätzte Stunden',
      hoursPlaceholder: 'z.B. 6',
      travelCost: 'Anfahrtskosten (EUR)',
      travelPlaceholder: 'z.B. 30',
      materialsCost: 'Materialkosten (EUR)',
      materialsPlaceholder: 'z.B. 100 (kann null sein)',
      otherCosts: 'Sonstige Kosten (EUR)',
      otherCostsPlaceholder: 'z.B. Entsorgung, Ersatzteile...',
      attachPhotos: 'Fotos anhängen (max. 3)',
      chooseFiles: 'Dateien wählen',
      filesSelected: 'ausgewählt',
      availablePeriod: 'Verfügbarer Zeitraum',
      fromDate: 'Von',
      toDate: 'Bis',
      notesOrDetails: 'Notizen oder Detailanfragen',
      notesPlaceholder: 'Schreiben Sie eventuelle Fragen oder Details...',
      termsAndConditions: 'Geschäftsbedingungen',
      termsPlaceholder: 'Zahlungsbedingungen, Zeitpläne, Ausschlüsse usw. angeben',
      total: 'Gesamt',
      send: 'Senden',
      invalidAmount: 'Gesamtbetrag ungültig',
      offerSentSuccess: 'Angebot erfolgreich gesendet ✅',
      offerSentError: 'Fehler beim Senden des Angebots',
      requestDetailTitle: 'Anfragendetails',
      urgency: 'Dringlichkeit',
      yes: 'Ja',
      no: 'Nein',
      preferredDays: 'Bevorzugte Tage',
      timeSlots: 'Zeitfenster',
      noPreference: 'Keine Präferenz',
    },

    // Settings
    settings: {
      title: 'Einstellungen',
      subtitle: 'Verwalten Sie Ihre persönlichen Daten und Einstellungen',
      myData: 'Meine Daten',
      name: 'Vorname',
      surname: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      address: 'Adresse',
      street: 'Straße',
      number: 'Hausnummer',
      cap: 'PLZ',
      city: 'Stadt',
      cancel: 'Abbrechen',
      save: 'Speichern',
      termsAndConditions: 'Allgemeine Geschäftsbedingungen',
      privacyPolicy: 'Datenschutzerklärung',
      needHelp: 'Benötigen Sie Hilfe?',
      deleteAccount: 'Konto löschen',
      changeProfileImage: 'Profilbild ändern',
      clientSince: 'Kunde seit',
      companySince: 'Unternehmen seit',
      dataUpdated: 'Daten aktualisiert',
      updateError: 'Fehler beim Aktualisieren',
      invalidImage: 'Wählen Sie ein gültiges Bild aus',
      imageTooLarge: 'Bild zu groß (max. 5MB)',
      profileImageUpdated: 'Profilbild aktualisiert',
      imageUpdateError: 'Fehler beim Aktualisieren des Bildes',
      imageLoadError: 'Fehler beim Laden des Bildes',
      deleteAccountTitle: 'Konto löschen',
      deleteAccountMessage: 'Teilen Sie uns den Grund für Ihre Entscheidung mit, wir bedauern dies sehr und möchten Ihnen helfen.',
      deleteReasonPlaceholder: 'Schreiben Sie hier den Grund...',
      evaluateSolution: 'Lassen Sie uns gemeinsam eine Lösung finden',
      confirmDeleteAccount: 'Konto endgültig löschen',
      requestSent: 'Anfrage an den Support gesendet',
      understood: 'Verstanden',
      lastUpdate: 'Letzte Aktualisierung',
    },

    // Company Settings
    companySettings: {
      companyData: 'Firmendaten',
      companyName: 'Firmenname',
      dangerWarning: 'Achtung: Diese Aktion ist unwiderruflich. Alle Ihre Daten werden dauerhaft gelöscht.',
    },

    // Categories (Artisan professions)
    categories: {
      'Idraulico': 'Klempner',
      'Elettricista': 'Elektriker',
      'Pulizie': 'Reinigung',
      'Giardinaggio': 'Gartenbau',
      'Traslochi': 'Umzüge',
      'Falegnameria': 'Schreinerei',
      'Imbianchino/Pittore': 'Maler/Anstreicher',
      'Pavimenti e Piastrelle': 'Böden und Fliesen',
      'Serramenti e Infissi': 'Fenster und Türen',
      'Fabbro': 'Schmied',
      'Riscaldamento e Climatizzazione': 'Heizung und Klimatechnik',
      'Antennista': 'Antenneninstallateur',
      'Muratore/Edilizia': 'Maurer/Bauwesen',
      'Cartongesso': 'Trockenbau',
      'Tetti e Coperture': 'Dächer und Bedachung',
      'Isolamento Termico': 'Wärmedämmung',
      'Tapparelle e Avvolgibili': 'Rollläden',
      'Vetrai': 'Glaser',
      'Parquet': 'Parkett',
      'Porte e Finestre': 'Türen und Fenster',
      'Cancelli Automatici': 'Automatische Tore',
      'Carpenteria Metallica': 'Metallbau',
      'Lattoniere': 'Spengler',
      'Spazzacamino': 'Schornsteinfeger',
      'Tende e Zanzariere': 'Vorhänge und Moskitonetze',
      'Manutenzione Giardini': 'Gartenpflege',
      'Potature': 'Baumschnitt',
      'Allarmi e Videosorveglianza': 'Alarmanlagen und Videoüberwachung',
      'Domotica': 'Hausautomation',
      'Fotovoltaico': 'Photovoltaik',
      'Caldaie e Stufe': 'Heizkessel und Öfen',
      'Pompe di Calore': 'Wärmepumpen',
      'Piscine': 'Schwimmbäder',
      'Pozzi e Trivellazioni': 'Brunnen und Bohrungen',
      'Disinfestazione': 'Schädlingsbekämpfung',
      'Sgomberi': 'Entrümpelung',
      'Ristrutturazioni Complete': 'Komplette Renovierungen',
      'Interior Design': 'Innenarchitektur',
      'Architetto': 'Architekt',
      'Geometra': 'Vermessungsingenieur',
      'Ingegnere': 'Ingenieur',
      'Consulente Energetico': 'Energieberater',
      'Ascensori e Montacarichi': 'Aufzüge und Lastenaufzüge',
      'Tapezziere': 'Tapezierer',
      'Verniciatura Industriale': 'Industrielackierung',
      'Lucidatura Pavimenti': 'Bodenpolitur',
      'Trattamento Marmo': 'Marmorbehandlung',
      'Impermeabilizzazioni': 'Abdichtungen',
      'Rifacimento Bagno': 'Badezimmerrenovierung',
      'Rifacimento Cucina': 'Küchenrenovierung',
      'Cabine Armadio': 'Begehbare Kleiderschränke',
      'Pergole e Gazebo': 'Pergolen und Pavillons',
      'Recinzioni': 'Zäune',
      'Sistemi di Irrigazione': 'Bewässerungssysteme',
      'Potatura Alberi': 'Baumschnitt',
      'Progettazione Giardini': 'Gartenplanung',
    },

    // Subscription
    subscription: {
      title: 'Abonnement',
      manage: 'Verwalten',
      cancelSubscription: 'Abonnement kündigen',
      activateSubscription: 'Abonnement aktivieren',
      subscriptionActive: 'Abonnement Aktiv',
      subscriptionCanceled: 'Abonnement Gekündigt',
      perMonth: 'pro Monat',
      currentMonthSummary: 'Zusammenfassung aktueller Monat',
      baseSubscription: 'Basis-Abonnement',
      unlockedContacts: 'Aktivierte Chats',
      estimatedTotal: 'Geschätzte Gesamtsumme',
      all: 'Alle',
      enterPassword: 'Passwort eingeben',
    },

    // Dashboard
    dashboard: {
      title: 'Dashboard',
      summary: 'Übersicht Ihrer Aktivitäten',
      requestsMade: 'Gestellte Anfragen',
      requestsMadeSubtitle: 'Alle Ihre Serviceanfragen anzeigen',
      offersReceived: 'Erhaltene Angebote',
      offersReceivedSubtitle: 'Angebote von Fachleuten prüfen',
      reviewsMade: 'Abgegebene Bewertungen',
      reviewsMadeSubtitle: 'Ihre Bewertungen für erhaltene Dienstleistungen',
      offersPending: 'Ausstehend',
      offersAccepted: 'Ausgewählt',
      offersRejected: 'Abgelehnt',
      reviewsSummary: 'Bewertungsübersicht',
      basedOnReviews: 'Basierend auf {{count}} Bewertungen',
      currentMonthBilling: 'Abrechnung aktueller Monat',
      subscription: 'Abonnement',
      contactsUnlocked: 'Freigeschaltete Kontakte',
      seeAll: 'Alles anzeigen',
      offersSent: 'Gesendete Angebote',
      viewAllOffers: 'Alle Ihre Angebote ansehen',
      offerStatus: 'Angebotsstatus',
      withdrawOffer: 'Angebot zurückziehen',
      offerWithdrawn: 'Angebot zurückgezogen',
      cannotWithdraw: 'Kann nicht zurückgezogen werden',
      company: 'Firma',
    },

    // UI Common
    ui: {
      usefulLinks: 'Nützliche Links',
      alreadyHaveAccount: 'Haben Sie bereits ein Konto?',
      login: 'Anmelden',
      logout: 'Abmelden',
      loading: 'Laden...',
      manageCompanyProfile: 'Verwalten Sie Ihr Firmenprofil',
      howToBeContacted: 'Wie möchten Sie kontaktiert werden?',
      companiesWillContact: 'Interessierte Unternehmen kontaktieren Sie direkt über diese Kontaktdaten',
      describeYourNeed: 'Beschreiben Sie, was Sie brauchen, und Sie werden direkt kontaktiert',
      requestPublished: 'Ihre Anfrage wurde veröffentlicht.',
      willBeContacted: 'Sie werden direkt von interessierten Unternehmen kontaktiert.',
      whatsapp: 'WhatsApp',
      phone: 'Telefon',
      email: 'E-Mail',
      yourEmail: 'Ihre E-Mail',
      yourNumber: 'Ihre Nummer (z.B. +41 79 123 4567)',
      enterContact: 'Geben Sie eine Kontaktmöglichkeit ein',
      monthlyPlan: 'Monatsplan',
      freeMonth: '3 Monate gratis',
      firstMonthFree: '3 Monate kostenlos, dann 49 CHF/Monat',
      threeMonthsFree: '3 Monate gratis',
      threeMonthsFreeThen: '3 Monate kostenlos, dann 49 CHF/Monat',
      companyData: 'Firmendaten',
      yourDataGdpr: 'Ihre Daten (DSGVO)',
      downloadAllData: 'Laden Sie alle Ihre persönlichen Daten im JSON-Format herunter.',
      exportMyData: 'Meine Daten exportieren',
      dataExported: 'Daten erfolgreich exportiert!',
      dataExportError: 'Fehler beim Datenexport',
      invoices: 'Rechnungen',
      allFilter: 'Alle',
      subscriptionFilter: 'Abonnement',
      contactFilter: 'Kontakt',
      noInvoices: 'Keine Rechnungen',
      invoiceWillBeGenerated: 'Die Rechnung wird automatisch am 1. des nächsten Monats erstellt',
      cancelSubscription: 'Abonnement kündigen',
      cancelConfirm: 'Sind Sie sicher, dass Sie das Abonnement kündigen möchten?',
      cancel: 'Abbrechen',
      yesImSure: 'Ja, ich bin sicher',
      enterPasswordToConfirm: 'Geben Sie Ihr Passwort zur Bestätigung ein.',
      back: 'Zurück',
      confirm: 'Bestätigen',
      offersReceived: 'Erhaltene Angebote',
      backToRequests: 'Zurück zu den Anfragen',
      offerDetail: 'Angebotsdetails',
      amount: 'Betrag',
      status: 'Status',
      pending: 'Ausstehend',
      accepted: 'Akzeptiert',
      rejected: 'Abgelehnt',
      type: 'Typ:',
      fixedPrice: 'Pauschalpreis',
      hourly: 'Stundensatz',
      price: 'Preis:',
      hourlyRate: 'Stundensatz:',
      notes: 'Notizen:',
      sentDate: 'Sendedatum',
      chooseThisCompany: 'Dieses Unternehmen wählen',
      close: 'Schließen',
      noOffers: 'Noch keine Angebote.',
      waiting: 'Wartend',
      inProgress: 'In Bearbeitung',
      completed: 'Abgeschlossen',
      canceled: 'Storniert',
      openChatWithCompany: 'Chat mit dem Unternehmen öffnen',
      noCompanySelected: 'Kein Unternehmen ausgewählt',
      companySelected: 'Unternehmen ausgewählt!',
      selectionError: 'Auswahlfehler',
      emailSent: 'E-Mail gesendet!',
      requestNewLink: 'Neuen Link anfordern',
      linkExpiredOrInvalid: 'Der Link ist möglicherweise abgelaufen oder ungültig.',
      nowLoginWithNewPassword: 'Sie können sich jetzt mit Ihrem neuen Passwort anmelden.',
      passwordMinLength: 'Das Passwort muss mindestens 6 Zeichen lang sein',
      passwordsDontMatch: 'Die Passwörter stimmen nicht überein',
      noBinding: 'Unverbindlich',
      chooseCompany: 'Unternehmen wählen',
      subscriptionInvoice: 'Abonnement-Rechnung',
      contactUnlocked: 'Kontakt freigeschaltet',
      freeForClients: 'Kostenlos für Privatpersonen',
      fastReplies: 'Schnelle Antworten',
      directContact: 'Direkter Kontakt',
      unlimitedRequests: 'Unbegrenzte Anfragen veröffentlichen',
      receiveContacts: 'Kontakte von Unternehmen erhalten',
      zeroCommissions: 'Keine Provisionen',
      accessAllRequests: 'Zugang zu allen Anfragen',
      contactClientsDirectly: 'Kunden direkt kontaktieren',
      allFilter2: 'Alle',
      allCategories: 'Alle',
      requestDetail: 'Anfragedetails',
      whoContactedYou: 'Wer hat Sie kontaktiert',
      deleteRequest: 'Anfrage löschen',
      users: 'Benutzer',
      requests: 'Anfragen',
      transactions: 'Transaktionen',
      userManagement: 'Benutzerverwaltung',
      recentRequests: 'Neueste Anfragen',
      recentTransactions: 'Neueste Transaktionen',
      changePassword: 'Passwort ändern',
    },
  },
  
  en: {
    // Common
    common: {
      close: 'Close',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      search: 'Search',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
      ok: 'OK',
      yes: 'Yes',
      no: 'No',
    },
    
    // Footer
    footer: {
      termsAndConditions: 'Terms and Conditions',
      privacyPolicy: 'Privacy Policy',
      copyright: '© 2025 I.F. Core Lab - All rights reserved',
      noReproduction: 'Any reproduction is prohibited',
    },
    
    // Cookie Banner
    cookie: {
      title: 'We use Cookies',
      message: 'This site uses technical cookies. By continuing to browse, you accept the use of cookies.',
      accept: 'Accept',
      moreInfo: 'Learn more',
    },
    
    // PWA Install Guide
    pwa: {
      title: 'Install ServiceGo',
      subtitle: 'Add the app to your home screen for quick access',
      androidTitle: 'On Android',
      androidStep1: 'Tap the menu ⋮ at the top right',
      androidStep2: 'Select "Add to Home screen"',
      androidStep3: 'Tap "Add"',
      iosTitle: 'On iPhone/iPad',
      iosStep1: 'Tap the share icon ⬆',
      iosStep2: 'Scroll and tap "Add to Home Screen"',
      iosStep3: 'Tap "Add" at the top right',
      skip: 'Continue without installing',
      dontShowAgain: 'Don\'t show again',
    },
    
    // Welcome
    welcome: {
      title: 'Welcome to JobConnect',
      startAsClient: 'Start as Client',
      registerCompany: 'Register Your Company',
      howItWorks: 'How it works?',
    },
    
    // Auth
    auth: {
      login: 'Login',
      logout: 'Logout',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Forgot password?',
      noAccount: 'Don\'t have an account?',
      hasAccount: 'Already have an account?',
      invalidCredentials: 'Invalid credentials',
      loginSuccess: 'Successfully logged in',
      resetPassword: 'Reset Password',
      resetPasswordDesc: 'Enter your email to receive the reset link',
      sendResetLink: 'Send Reset Link',
      resetEmailSent: 'If the email exists, you will receive a reset link',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      passwordUpdated: 'Password successfully updated',
      invalidToken: 'Invalid or expired token',
      backToLogin: 'Back to Login',
      verifyEmail: 'Verify Email',
      verifyEmailDesc: 'Click the button to verify your email',
      emailVerified: 'Email successfully verified',
      verificationSent: 'Verification email sent',
      tooManyRequests: 'Too many requests, please try again later',
      welcomeBack: 'Welcome back!',
      loginSubtitle: 'Sign in to your account to continue',
      haveAccount: 'Already have an account?',
    },
    
    // Navigation
    nav: {
      home: 'Home',
      dashboard: 'Dashboard',
      requests: 'Requests',
      offers: 'Offers',
      messages: 'Messages',
      chat: 'Chat',
      settings: 'Settings',
      profile: 'Profile',
      registerAsClient: 'Register as Client',
      registerAsCompany: 'Register as Company',
    },
    
    // Client Dashboard
    clientDashboard: {
      title: 'Client Dashboard',
      welcome: 'Welcome',
      myRequests: 'My requests',
      newRequest: 'New Request',
      offersReceived: 'Offers received',
      viewOffers: 'View Offers',
      pending: 'Pending',
      accepted: 'Accepted',
      rejected: 'Rejected',
      open: 'Open',
      assigned: 'In progress',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    
    // Company Dashboard
    companyDashboard: {
      title: 'Company Dashboard',
      welcome: 'Welcome',
      openRequests: 'Open Requests',
      offersSent: 'Sent Offers',
      statistics: 'Statistics',
      monthlyRevenue: 'Monthly revenue',
      subscription: 'Subscription',
      allOffersSent: 'All sent offers',
      viewAll: 'View all',
    },
    
    // New Request
    newRequest: {
      title: 'New Request',
      selectCategory: 'Select the craftsman you need',
      requestTitle: 'Request Title',
      description: 'Job Description',
      descriptionPlaceholder: 'Describe the work to be done in detail...',
      attachPhotos: 'Attach photos',
      maxPhotos: 'Max 5 photos',
      uploadPhoto: 'Upload photo',
      takePhoto: 'Take photo',
      address: 'Work address',
      street: 'Street',
      number: 'Number',
      city: 'City',
      district: 'District',
      selectDistrict: 'Select District',
      cap: 'Postal Code',
      preferredDays: 'Preferred days',
      selectDays: 'Select at least one day',
      preferredSlots: 'Preferred time slots',
      selectSlots: 'Select at least one time slot',
      urgent: 'Urgent',
      submitRequest: 'Submit Request',
      requestPublished: 'Your request has been published!',
      excellent: 'Excellent!',
      // Validation
      selectCategoryError: 'Select a category',
      titleError: 'Enter the request title',
      descriptionError: 'Enter the job description',
      capError: 'Enter the postal code',
      streetError: 'Enter the street',
      numberError: 'Enter the number',
      districtError: 'Select the district',
      daysError: 'Select at least one preferred day',
      slotsError: 'Select at least one preferred time slot',
    },
    
    // Requests
    requests: {
      myRequests: 'My requests',
      noRequests: 'No requests yet.',
      requestSentOn: 'Request sent on',
      offersReceived: 'Offers received',
      urgency: 'Urgency',
      status: 'Status',
      deleteRequest: 'Delete request',
      confirmDelete: 'Are you sure you want to delete this request?',
      requestDeleted: 'The request has been successfully deleted',
      perfect: 'Perfect!',
      viewDetail: 'View detail',
    },
    
    // Offers
    offers: {
      offerDetail: 'Offer detail',
      totalAmount: 'Total Amount',
      offerDetails: 'Offer Details',
      offerType: 'Offer type:',
      fixedPrice: 'Fixed price',
      hourly: 'Hourly',
      hourlyRate: 'Hourly rate:',
      workers: 'Number of workers:',
      estimatedHours: 'Estimated hours:',
      travelCost: 'Travel cost:',
      materialsCost: 'Materials cost:',
      otherCosts: 'Other costs:',
      workPeriod: 'Work period',
      from: 'From:',
      to: 'To:',
      additionalNotes: 'Additional notes',
      terms: 'Terms and conditions',
      sentOn: 'Sent on',
      chooseCompany: 'Choose this company',
      withdrawOffer: 'Withdraw offer',
      noOffers: 'No offers yet.',
      sendOffer: 'Send Offer',
      offerSent: 'Offer sent successfully',
      openChat: 'Open chat with company',
    },
    
    // Messages/Chat
    messages: {
      title: 'Messages',
      noConversations: 'No conversations.',
      noConversationsHint: 'Accept an offer to start chatting with a company!',
      searchConversations: 'Search conversations...',
      searchPlaceholder: 'Search...',
      writeMessage: 'Write a message...',
      noMessages: 'No messages yet. Start the conversation!',
      loadingError: 'Error loading messages',
      sendError: 'Error sending message',
    },
    
    // Settings
    settings: {
      title: 'Settings',
      subtitle: 'Manage your personal data and preferences',
      myData: 'My data',
      personalData: 'Personal Data',
      contacts: 'Contacts',
      address: 'Address',
      preferences: 'Preferences',
      notifications: 'Notifications',
      receiveUpdates: 'Receive updates on requests',
      name: 'First name',
      surname: 'Last name',
      companyName: 'Company name',
      phone: 'Phone',
      vatNumber: 'UID / Commerce Registration',
      changePhoto: 'Change profile picture',
      saveChanges: 'Save changes',
      dataUpdated: 'Data updated',
      profileImageUpdated: 'Profile picture updated',
      invalidImage: 'Select a valid image',
      imageTooLarge: 'Image too large (max 5MB)',
      updateError: 'Error updating',
      termsAndConditions: 'Terms and Conditions',
      privacyPolicy: 'Privacy Policy',
      deleteAccount: 'Delete account',
      deleteAccountTitle: 'Delete account',
      deleteAccountMessage: 'Let us know why you want to leave. We are very sorry and would like to help.',
      deleteReasonPlaceholder: 'Write the reason here...',
      findSolution: 'Let\'s find a solution together',
      confirmDelete: 'Permanently delete account',
      helpTitle: 'Need help?',
      clientSince: 'Client since',
      understood: 'Understood',
      language: 'Language',
    },
    
    // Days
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    
    // Time slots
    timeSlots: {
      morning: 'Morning (8-12)',
      afternoon: 'Afternoon (13-17)',
      evening: 'Evening (18-20)',
      any: 'Any time',
    },
    
    // Status
    status: {
      pending: 'Pending',
      won: 'Accepted',
      lost: 'Rejected',
      withdrawn: 'Withdrawn',
      expired: 'Expired',
      open: 'Open',
      assigned: 'In progress',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },

    // Register Client
    registerClient: {
      title: 'New Client',
      subtitle: 'Fill in all fields to complete registration',
      personalData: 'Personal Data',
      name: 'First Name',
      surname: 'Last Name',
      contacts: 'Contacts',
      email: 'Email',
      phone: 'Phone Number',
      address: 'Address',
      street: 'Street',
      number: 'Number',
      cap: 'Postal Code',
      city: 'City',
      password: 'Password',
      submitButton: 'Register Client',
      successMessage: 'Registration completed',
      errorMessage: 'Registration error',
      register: 'Register',
    },

    // Register Company
    registerCompany: {
      title: 'Company Registration',
      subtitle: 'Complete your company data to get started',
      companyName: 'Company Name *',
      companyNamePlaceholder: 'e.g., ABC Solutions Ltd',
      street: 'Street *',
      streetPlaceholder: 'Main Street',
      number: 'Number *',
      numberPlaceholder: 'e.g., 42',
      postalCode: 'Postal Code *',
      postalCodePlaceholder: 'e.g., 6900',
      city: 'City *',
      cityPlaceholder: 'e.g., Zurich',
      fullAddress: 'Full Address *',
      fullAddressPlaceholder: 'Street, number, postal code, city',
      commerceNumber: 'UID (Company ID) *',
      commerceNumberPlaceholder: 'CHE-123.456.789',
      professionalType: 'Type of Professional Service *',
      professionalTypePlaceholder: 'Select profession',
      businessEmail: 'Business Email *',
      businessEmailPlaceholder: 'info@company.ch',
      phoneNumber: 'Phone Number *',
      phoneNumberPlaceholder: '+41 XX XXX XX XX',
      password: 'Password',
      subscriptionPlan: 'Subscription Plan',
      pricePerMonth: '/month',
      plusContactFee: 'Chat with clients included',
      planFeature1: 'Unlimited platform access',
      planFeature2: 'Concrete job requests',
      planFeature3: 'Priority customer support',
      planFeature4: 'Get positive reviews and show what you\'re made of!',
      subscribeButton: 'Subscribe now!',
      successMessage: 'Company registration completed',
      errorMessage: 'Company registration error',
    },

    // Bottom Navigation
    bottomNav: {
      home: 'Home',
      new: 'New',
      chat: 'Chat',
      profile: 'Profile',
      support: 'Support',
    },

    // How It Works
    howItWorks: {
      title: 'How it works?',
      forCustomers: 'For Customers',
      customerStep1: 'Describe the job',
      customerStep1Detail: ': details and up to 5 photos (free).',
      customerStep2: 'Receive up to 3 offers',
      customerStep2Detail: ' from nearby companies.',
      customerStep3: 'Choose the company',
      customerStep3Detail: ' you prefer.',
      customerStep4: 'It\'s all free',
      customerStep4Detail: ' for you.',
      iAmCustomer: 'I\'m a Customer',
      forCompanies: 'For Companies',
      companyStep1: 'Browse requests',
      companyStep1Detail: ' in your area and send an offer.',
      companyStep2: 'Contact client',
      companyStep2Detail: ' when you\'re chosen: direct and free chat.',
      companyStep3: 'Simple subscription',
      companyStep3Detail: ': CHF 49/month after 3 months free.',
      iAmCompany: 'I\'m a Company',
    },

    // Company Requests / Open Requests
    companyRequests: {
      title: 'Open Requests',
      filterDistrict: 'District',
      allDistricts: 'All districts',
      filterCategory: 'Category',
      applyFilters: 'Filter',
      offersCount: 'offers',
      viewButton: 'View',
      sendOfferButton: 'Send Offer',
      noRequests: 'No open requests',
      today: 'today',
      day: 'day',
      days: 'days',
      week: 'week',
      weeks: 'weeks',
      offerDialogTitle: 'Fill out the offer',
      offerType: 'Offer type',
      offerTypeFixed: 'Fixed price',
      offerTypeHourly: 'Hourly',
      fixedAmount: 'Fixed amount (EUR)',
      fixedAmountPlaceholder: 'e.g., 1200',
      hourlyRate: 'Hourly rate (EUR/hour)',
      hourlyRatePlaceholder: 'e.g., 80',
      numberOfWorkers: 'Number of workers',
      workersPlaceholder: 'e.g., 2',
      estimatedHours: 'Estimated hours',
      hoursPlaceholder: 'e.g., 6',
      travelCost: 'Travel cost (EUR)',
      travelPlaceholder: 'e.g., 30',
      materialsCost: 'Materials cost (EUR)',
      materialsPlaceholder: 'e.g., 100 (can be zero)',
      otherCosts: 'Other costs (EUR)',
      otherCostsPlaceholder: 'e.g., disposal, spare parts...',
      attachPhotos: 'Attach photos (max 3)',
      chooseFiles: 'Choose files',
      filesSelected: 'selected',
      availablePeriod: 'Available period',
      fromDate: 'From',
      toDate: 'To',
      notesOrDetails: 'Notes or detail requests',
      notesPlaceholder: 'Write any questions or details...',
      termsAndConditions: 'Terms and conditions',
      termsPlaceholder: 'Specify payment terms, timelines, exclusions, etc.',
      total: 'Total',
      send: 'Send',
      invalidAmount: 'Invalid total amount',
      offerSentSuccess: 'Offer sent successfully ✅',
      offerSentError: 'Error sending offer',
      requestDetailTitle: 'Request details',
      urgency: 'Urgency',
      yes: 'Yes',
      no: 'No',
      preferredDays: 'Preferred days',
      timeSlots: 'Time slots',
      noPreference: 'No preference',
    },

    // Settings
    settings: {
      title: 'Settings',
      subtitle: 'Manage your personal data and preferences',
      myData: 'My data',
      name: 'First Name',
      surname: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      street: 'Street',
      number: 'Number',
      cap: 'Postal Code',
      city: 'City',
      cancel: 'Cancel',
      save: 'Save',
      termsAndConditions: 'Terms and Conditions',
      privacyPolicy: 'Privacy Policy',
      needHelp: 'Need help?',
      deleteAccount: 'Delete account',
      changeProfileImage: 'Change profile image',
      clientSince: 'Client since',
      companySince: 'Company since',
      dataUpdated: 'Data updated',
      updateError: 'Update error',
      invalidImage: 'Select a valid image',
      imageTooLarge: 'Image too large (max 5MB)',
      profileImageUpdated: 'Profile image updated',
      imageUpdateError: 'Error updating image',
      imageLoadError: 'Error loading image',
      deleteAccountTitle: 'Delete account',
      deleteAccountMessage: 'Let us know why you\'re leaving, we\'re sorry and would like to help.',
      deleteReasonPlaceholder: 'Write your reason here...',
      evaluateSolution: 'Let\'s find a solution together',
      confirmDeleteAccount: 'Permanently delete account',
      requestSent: 'Request sent to support',
      understood: 'Understood',
      lastUpdate: 'Last update',
    },

    // Company Settings
    companySettings: {
      companyData: 'Company Data',
      companyName: 'Company Name',
      dangerWarning: 'Warning: this action is irreversible. All your data will be permanently deleted.',
    },

    // Categories (Artisan professions)
    categories: {
      'Idraulico': 'Plumber',
      'Elettricista': 'Electrician',
      'Pulizie': 'Cleaning',
      'Giardinaggio': 'Gardening',
      'Traslochi': 'Moving',
      'Falegnameria': 'Carpentry',
      'Imbianchino/Pittore': 'Painter/Decorator',
      'Pavimenti e Piastrelle': 'Flooring and Tiles',
      'Serramenti e Infissi': 'Windows and Doors',
      'Fabbro': 'Locksmith',
      'Riscaldamento e Climatizzazione': 'Heating and Air Conditioning',
      'Antennista': 'Antenna Installer',
      'Muratore/Edilizia': 'Mason/Construction',
      'Cartongesso': 'Drywall',
      'Tetti e Coperture': 'Roofing',
      'Isolamento Termico': 'Thermal Insulation',
      'Tapparelle e Avvolgibili': 'Shutters and Blinds',
      'Vetrai': 'Glazier',
      'Parquet': 'Parquet',
      'Porte e Finestre': 'Doors and Windows',
      'Cancelli Automatici': 'Automatic Gates',
      'Carpenteria Metallica': 'Metal Carpentry',
      'Lattoniere': 'Tinsmith',
      'Spazzacamino': 'Chimney Sweep',
      'Tende e Zanzariere': 'Curtains and Mosquito Nets',
      'Manutenzione Giardini': 'Garden Maintenance',
      'Potature': 'Pruning',
      'Allarmi e Videosorveglianza': 'Alarms and Video Surveillance',
      'Domotica': 'Home Automation',
      'Fotovoltaico': 'Solar Panels',
      'Caldaie e Stufe': 'Boilers and Stoves',
      'Pompe di Calore': 'Heat Pumps',
      'Piscine': 'Swimming Pools',
      'Pozzi e Trivellazioni': 'Wells and Drilling',
      'Disinfestazione': 'Pest Control',
      'Sgomberi': 'House Clearance',
      'Ristrutturazioni Complete': 'Complete Renovations',
      'Interior Design': 'Interior Design',
      'Architetto': 'Architect',
      'Geometra': 'Surveyor',
      'Ingegnere': 'Engineer',
      'Consulente Energetico': 'Energy Consultant',
      'Ascensori e Montacarichi': 'Elevators and Lifts',
      'Tapezziere': 'Upholsterer',
      'Verniciatura Industriale': 'Industrial Painting',
      'Lucidatura Pavimenti': 'Floor Polishing',
      'Trattamento Marmo': 'Marble Treatment',
      'Impermeabilizzazioni': 'Waterproofing',
      'Rifacimento Bagno': 'Bathroom Renovation',
      'Rifacimento Cucina': 'Kitchen Renovation',
      'Cabine Armadio': 'Walk-in Closets',
      'Pergole e Gazebo': 'Pergolas and Gazebos',
      'Recinzioni': 'Fencing',
      'Sistemi di Irrigazione': 'Irrigation Systems',
      'Potatura Alberi': 'Tree Pruning',
      'Progettazione Giardini': 'Garden Design',
    },

    // Subscription
    subscription: {
      title: 'Subscription',
      manage: 'Manage',
      cancelSubscription: 'Cancel subscription',
      activateSubscription: 'Activate subscription',
      subscriptionActive: 'Subscription Active',
      subscriptionCanceled: 'Subscription Canceled',
      perMonth: 'per month',
      currentMonthSummary: 'Current Month Summary',
      baseSubscription: 'Base subscription',
      unlockedContacts: 'Active chats',
      estimatedTotal: 'Estimated total',
      all: 'All',
      enterPassword: 'Enter password',
    },

    // Dashboard
    dashboard: {
      title: 'Dashboard',
      summary: 'Overview of your activities',
      requestsMade: 'Requests Made',
      requestsMadeSubtitle: 'View all your service requests',
      offersReceived: 'Offers Received',
      offersReceivedSubtitle: 'Check offers from professionals',
      reviewsMade: 'Reviews Made',
      reviewsMadeSubtitle: 'Your ratings for services received',
      offersPending: 'Pending',
      offersAccepted: 'Selected',
      offersRejected: 'Rejected',
      reviewsSummary: 'Reviews Summary',
      basedOnReviews: 'Based on {{count}} reviews',
      currentMonthBilling: 'Current month billing',
      subscription: 'Subscription',
      contactsUnlocked: 'Unlocked Contacts',
      seeAll: 'See All',
      offersSent: 'Sent Offers',
      viewAllOffers: 'View all your offers',
      offerStatus: 'Offer status',
      withdrawOffer: 'Withdraw offer',
      offerWithdrawn: 'Offer withdrawn',
      cannotWithdraw: 'Cannot withdraw',
      company: 'Company',
    },

    // UI Common
    ui: {
      usefulLinks: 'Useful Links',
      alreadyHaveAccount: 'Already have an account?',
      login: 'Login',
      logout: 'Logout',
      loading: 'Loading...',
      manageCompanyProfile: 'Manage your company profile',
      howToBeContacted: 'How would you like to be contacted?',
      companiesWillContact: 'Interested companies will contact you directly through this contact method',
      describeYourNeed: 'Describe what you need and you\'ll be contacted directly',
      requestPublished: 'Your request has been published.',
      willBeContacted: 'You will be contacted directly by interested companies.',
      whatsapp: 'WhatsApp',
      phone: 'Phone',
      email: 'Email',
      yourEmail: 'Your email',
      yourNumber: 'Your number (e.g. +41 79 123 4567)',
      enterContact: 'Enter a contact method',
      monthlyPlan: 'Monthly Plan',
      freeMonth: '3 months free',
      firstMonthFree: '3 months free, then CHF 49/month',
      threeMonthsFree: '3 months free',
      threeMonthsFreeThen: '3 months free, then CHF 49/month',
      companyData: 'Company Data',
      yourDataGdpr: 'Your Data (GDPR)',
      downloadAllData: 'Download all your personal data in JSON format.',
      exportMyData: 'Export my data',
      dataExported: 'Data exported successfully!',
      dataExportError: 'Error exporting data',
      invoices: 'Invoices',
      allFilter: 'All',
      subscriptionFilter: 'Subscription',
      contactFilter: 'Contact',
      noInvoices: 'No invoices',
      invoiceWillBeGenerated: 'The invoice will be automatically generated on the 1st of next month',
      cancelSubscription: 'Cancel subscription',
      cancelConfirm: 'Are you sure you want to cancel the subscription?',
      cancel: 'Cancel',
      yesImSure: 'Yes, I\'m sure',
      enterPasswordToConfirm: 'Enter your password to confirm.',
      back: 'Back',
      confirm: 'Confirm',
      offersReceived: 'Offers received',
      backToRequests: 'Back to requests',
      offerDetail: 'Offer Detail',
      amount: 'Amount',
      status: 'Status',
      pending: 'Pending',
      accepted: 'Accepted',
      rejected: 'Rejected',
      type: 'Type:',
      fixedPrice: 'Fixed price',
      hourly: 'Hourly',
      price: 'Price:',
      hourlyRate: 'Hourly rate:',
      notes: 'Notes:',
      sentDate: 'Sent date',
      chooseThisCompany: 'Choose this company',
      close: 'Close',
      noOffers: 'No offers yet.',
      waiting: 'Waiting',
      inProgress: 'In Progress',
      completed: 'Completed',
      canceled: 'Canceled',
      openChatWithCompany: 'Open chat with company',
      noCompanySelected: 'No company selected',
      companySelected: 'Company selected!',
      selectionError: 'Selection error',
      emailSent: 'Email Sent!',
      requestNewLink: 'Request new link',
      linkExpiredOrInvalid: 'The link may have expired or is invalid.',
      nowLoginWithNewPassword: 'You can now sign in with your new password.',
      passwordMinLength: 'Password must be at least 6 characters',
      passwordsDontMatch: 'Passwords don\'t match',
      noBinding: 'No commitment',
      chooseCompany: 'Choose company',
      subscriptionInvoice: 'Subscription Invoice',
      contactUnlocked: 'Contact Unlocked',
      freeForClients: 'Free for individuals',
      fastReplies: 'Fast replies',
      directContact: 'Direct contact',
      unlimitedRequests: 'Publish unlimited requests',
      receiveContacts: 'Receive contacts from companies',
      zeroCommissions: 'Zero commissions',
      accessAllRequests: 'Access all requests',
      contactClientsDirectly: 'Contact clients directly',
      allFilter2: 'All',
      allCategories: 'All',
      requestDetail: 'Request Detail',
      whoContactedYou: 'Who contacted you',
      deleteRequest: 'Delete request',
      users: 'Users',
      requests: 'Requests',
      transactions: 'Transactions',
      userManagement: 'User Management',
      recentRequests: 'Recent Requests',
      recentTransactions: 'Recent Transactions',
      changePassword: 'Change Password',
    },
  },
  
  fr: {
    // Common
    common: {
      close: 'Fermer',
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      search: 'Rechercher',
      loading: 'Chargement...',
      error: 'Erreur',
      success: 'Succès',
      confirm: 'Confirmer',
      back: 'Retour',
      next: 'Suivant',
      submit: 'Soumettre',
      ok: 'OK',
      yes: 'Oui',
      no: 'Non',
    },
    
    // Footer
    footer: {
      termsAndConditions: 'Conditions d\'utilisation',
      privacyPolicy: 'Politique de confidentialité',
      copyright: '© 2025 I.F. Core Lab - Tous droits réservés',
      noReproduction: 'Toute reproduction est interdite',
    },
    
    // Cookie Banner
    cookie: {
      title: 'Nous utilisons des Cookies',
      message: 'Ce site utilise des cookies techniques. En continuant à naviguer, vous acceptez l\'utilisation des cookies.',
      accept: 'Accepter',
      moreInfo: 'En savoir plus',
    },
    
    // PWA Install Guide
    pwa: {
      title: 'Installer ServiceGo',
      subtitle: 'Ajoutez l\'application à votre écran d\'accueil',
      androidTitle: 'Sur Android',
      androidStep1: 'Appuyez sur le menu ⋮ en haut à droite',
      androidStep2: 'Sélectionnez "Ajouter à l\'écran d\'accueil"',
      androidStep3: 'Appuyez sur "Ajouter"',
      iosTitle: 'Sur iPhone/iPad',
      iosStep1: 'Appuyez sur l\'icône de partage ⬆',
      iosStep2: 'Faites défiler et appuyez sur "Sur l\'écran d\'accueil"',
      iosStep3: 'Appuyez sur "Ajouter" en haut à droite',
      skip: 'Continuer sans installer',
      dontShowAgain: 'Ne plus afficher',
    },
    
    // Welcome
    welcome: {
      title: 'Bienvenue sur JobConnect',
      startAsClient: 'Commencer en tant que client',
      registerCompany: 'Enregistrez votre entreprise',
      howItWorks: 'Comment ça marche?',
    },
    
    // Auth
    auth: {
      login: 'Se connecter',
      logout: 'Se déconnecter',
      register: 'S\'inscrire',
      email: 'Email',
      password: 'Mot de passe',
      forgotPassword: 'Mot de passe oublié?',
      noAccount: 'Vous n\'avez pas de compte?',
      hasAccount: 'Vous avez déjà un compte?',
      invalidCredentials: 'Identifiants invalides',
      loginSuccess: 'Connexion réussie',
      resetPassword: 'Réinitialiser le mot de passe',
      resetPasswordDesc: 'Entrez votre email pour recevoir le lien de réinitialisation',
      sendResetLink: 'Envoyer le lien de réinitialisation',
      resetEmailSent: 'Si l\'email existe, vous recevrez un lien de réinitialisation',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      passwordUpdated: 'Mot de passe mis à jour avec succès',
      invalidToken: 'Token invalide ou expiré',
      backToLogin: 'Retour à la connexion',
      verifyEmail: 'Vérifier l\'email',
      verifyEmailDesc: 'Cliquez sur le bouton pour vérifier votre email',
      emailVerified: 'Email vérifié avec succès',
      verificationSent: 'Email de vérification envoyé',
      tooManyRequests: 'Trop de demandes, veuillez réessayer plus tard',
    },
    
    // Navigation
    nav: {
      home: 'Accueil',
      dashboard: 'Tableau de bord',
      requests: 'Demandes',
      offers: 'Offres',
      messages: 'Messages',
      chat: 'Chat',
      settings: 'Paramètres',
      profile: 'Profil',
      registerAsClient: 'S\'inscrire comme Client',
      registerAsCompany: 'S\'inscrire comme Entreprise',
    },
    
    // Client Dashboard
    clientDashboard: {
      title: 'Tableau de bord client',
      welcome: 'Bienvenue',
      myRequests: 'Mes demandes',
      newRequest: 'Nouvelle demande',
      offersReceived: 'Offres reçues',
      viewOffers: 'Voir les offres',
      pending: 'En attente',
      accepted: 'Acceptées',
      rejected: 'Refusées',
      open: 'Ouvertes',
      assigned: 'En cours',
      completed: 'Terminées',
      cancelled: 'Annulées',
    },
    
    // Company Dashboard
    companyDashboard: {
      title: 'Tableau de bord entreprise',
      welcome: 'Bienvenue',
      openRequests: 'Demandes ouvertes',
      offersSent: 'Offres envoyées',
      statistics: 'Statistiques',
      monthlyRevenue: 'Chiffre d\'affaires mensuel',
      subscription: 'Abonnement',
      allOffersSent: 'Toutes les offres envoyées',
      viewAll: 'Voir tout',
    },
    
    // New Request
    newRequest: {
      title: 'Nouvelle demande',
      selectCategory: 'Sélectionnez l\'artisan dont vous avez besoin',
      requestTitle: 'Titre de la demande',
      description: 'Description du travail',
      descriptionPlaceholder: 'Décrivez le travail à effectuer en détail...',
      attachPhotos: 'Joindre des photos',
      maxPhotos: 'Max 5 photos',
      uploadPhoto: 'Télécharger une photo',
      takePhoto: 'Prendre une photo',
      address: 'Adresse du travail',
      street: 'Rue',
      number: 'Numéro',
      city: 'Ville',
      district: 'District',
      selectDistrict: 'Sélectionner le district',
      cap: 'Code postal',
      preferredDays: 'Jours préférés',
      selectDays: 'Sélectionnez au moins un jour',
      preferredSlots: 'Créneaux horaires préférés',
      selectSlots: 'Sélectionnez au moins un créneau',
      urgent: 'Urgent',
      submitRequest: 'Envoyer la demande',
      requestPublished: 'Votre demande a été publiée!',
      excellent: 'Excellent!',
      // Validation
      selectCategoryError: 'Sélectionnez une catégorie',
      titleError: 'Entrez le titre de la demande',
      descriptionError: 'Entrez la description du travail',
      capError: 'Entrez le code postal',
      streetError: 'Entrez la rue',
      numberError: 'Entrez le numéro',
      districtError: 'Sélectionnez le district',
      daysError: 'Sélectionnez au moins un jour préféré',
      slotsError: 'Sélectionnez au moins un créneau préféré',
    },
    
    // Requests
    requests: {
      myRequests: 'Mes demandes',
      noRequests: 'Aucune demande pour le moment.',
      requestSentOn: 'Demande envoyée le',
      offersReceived: 'Offres reçues',
      urgency: 'Urgence',
      status: 'Statut',
      deleteRequest: 'Supprimer la demande',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette demande?',
      requestDeleted: 'La demande a été supprimée avec succès',
      perfect: 'Parfait!',
      viewDetail: 'Voir les détails',
    },
    
    // Offers
    offers: {
      offerDetail: 'Détails de l\'offre',
      totalAmount: 'Montant total',
      offerDetails: 'Détails de l\'offre',
      offerType: 'Type d\'offre:',
      fixedPrice: 'Prix forfaitaire',
      hourly: 'À l\'heure',
      hourlyRate: 'Tarif horaire:',
      workers: 'Nombre d\'ouvriers:',
      estimatedHours: 'Heures estimées:',
      travelCost: 'Frais de déplacement:',
      materialsCost: 'Coût des matériaux:',
      otherCosts: 'Autres coûts:',
      workPeriod: 'Période de travail',
      from: 'Du:',
      to: 'Au:',
      additionalNotes: 'Notes supplémentaires',
      terms: 'Conditions générales',
      sentOn: 'Envoyé le',
      chooseCompany: 'Choisir cette entreprise',
      withdrawOffer: 'Retirer l\'offre',
      noOffers: 'Aucune offre pour le moment.',
      sendOffer: 'Envoyer l\'offre',
      offerSent: 'Offre envoyée avec succès',
      openChat: 'Ouvrir le chat avec l\'entreprise',
    },
    
    // Messages/Chat
    messages: {
      title: 'Messages',
      noConversations: 'Aucune conversation.',
      noConversationsHint: 'Acceptez une offre pour commencer à discuter avec une entreprise!',
      searchConversations: 'Rechercher des conversations...',
      searchPlaceholder: 'Rechercher...',
      writeMessage: 'Écrire un message...',
      noMessages: 'Aucun message pour le moment. Commencez la conversation!',
      loadingError: 'Erreur lors du chargement des messages',
      sendError: 'Erreur lors de l\'envoi du message',
    },
    
    // Settings
    settings: {
      title: 'Paramètres',
      subtitle: 'Gérez vos données personnelles et préférences',
      myData: 'Mes données',
      personalData: 'Données personnelles',
      contacts: 'Contacts',
      address: 'Adresse',
      preferences: 'Préférences',
      notifications: 'Notifications',
      receiveUpdates: 'Recevoir des mises à jour sur les demandes',
      name: 'Prénom',
      surname: 'Nom',
      companyName: 'Raison sociale',
      phone: 'Téléphone',
      vatNumber: 'Numéro TVA / UID',
      changePhoto: 'Changer la photo de profil',
      saveChanges: 'Enregistrer les modifications',
      dataUpdated: 'Données mises à jour',
      profileImageUpdated: 'Photo de profil mise à jour',
      invalidImage: 'Sélectionnez une image valide',
      imageTooLarge: 'Image trop volumineuse (max 5Mo)',
      updateError: 'Erreur lors de la mise à jour',
      termsAndConditions: 'Conditions générales',
      privacyPolicy: 'Politique de confidentialité',
      deleteAccount: 'Supprimer le compte',
      deleteAccountTitle: 'Supprimer le compte',
      deleteAccountMessage: 'Faites-nous savoir pourquoi vous souhaitez partir. Nous sommes vraiment désolés et aimerions vous aider.',
      deleteReasonPlaceholder: 'Écrivez la raison ici...',
      findSolution: 'Trouvons une solution ensemble',
      confirmDelete: 'Supprimer définitivement le compte',
      helpTitle: 'Besoin d\'aide?',
      clientSince: 'Client depuis',
      understood: 'Compris',
      language: 'Langue',
    },
    
    // Days
    days: {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
    },
    
    // Time slots
    timeSlots: {
      morning: 'Matin (8-12)',
      afternoon: 'Après-midi (13-17)',
      evening: 'Soir (18-20)',
      any: 'Indifférent',
    },
    
    // Status
    status: {
      pending: 'En attente',
      won: 'Acceptée',
      lost: 'Refusée',
      withdrawn: 'Retirée',
      expired: 'Expirée',
      open: 'Ouverte',
      assigned: 'En cours',
      completed: 'Terminée',
      cancelled: 'Annulée',
    },

    // Register Client
    registerClient: {
      title: 'Nouveau Client',
      subtitle: 'Remplissez tous les champs pour compléter l\'inscription',
      personalData: 'Données personnelles',
      name: 'Prénom',
      surname: 'Nom',
      contacts: 'Contacts',
      email: 'Email',
      phone: 'Numéro de téléphone',
      address: 'Adresse',
      street: 'Rue',
      number: 'Numéro',
      cap: 'Code postal',
      city: 'Localité',
      password: 'Mot de passe',
      submitButton: 'Enregistrer le client',
      successMessage: 'Inscription terminée',
      errorMessage: 'Erreur d\'inscription',
    },

    // Register Company
    registerCompany: {
      title: 'Inscription Entreprise',
      subtitle: 'Complétez les données de votre entreprise pour commencer',
      companyName: 'Nom de l\'entreprise *',
      companyNamePlaceholder: 'Ex. ABC Solutions SA',
      street: 'Rue *',
      streetPlaceholder: 'Rue principale',
      number: 'Numéro *',
      numberPlaceholder: 'Ex. 42',
      postalCode: 'Code postal *',
      postalCodePlaceholder: 'Ex. 1000',
      city: 'Ville *',
      cityPlaceholder: 'Ex. Lausanne',
      fullAddress: 'Adresse complète *',
      fullAddressPlaceholder: 'Rue, numéro, code postal, ville',
      commerceNumber: 'Numéro du registre du commerce *',
      commerceNumberPlaceholder: 'CHE-123.456.789',
      professionalType: 'Type de service professionnel *',
      professionalTypePlaceholder: 'Sélectionner la profession',
      businessEmail: 'Email professionnel *',
      businessEmailPlaceholder: 'info@entreprise.ch',
      phoneNumber: 'Numéro de téléphone *',
      phoneNumberPlaceholder: '+41 XX XXX XX XX',
      password: 'Mot de passe',
      subscriptionPlan: 'Plan d\'abonnement',
      pricePerMonth: '/mois',
      plusContactFee: 'Chat avec les clients incluse',
      planFeature1: 'Accès illimité à la plateforme',
      planFeature2: 'Demandes de travail concrètes',
      planFeature3: 'Support client prioritaire',
      planFeature4: 'Obtenez des avis positifs et montrez de quoi vous êtes capable!',
      subscribeButton: 'S\'abonner maintenant!',
      successMessage: 'Inscription de l\'entreprise terminée',
      errorMessage: 'Erreur d\'inscription de l\'entreprise',
    },

    // Bottom Navigation
    bottomNav: {
      home: 'Accueil',
      new: 'Nouveau',
      chat: 'Chat',
      profile: 'Profil',
      support: 'Support',
    },

    // How It Works
    howItWorks: {
      title: 'Comment ça marche?',
      forCustomers: 'Pour les Clients',
      customerStep1: 'Décrivez le travail',
      customerStep1Detail: ': détails et jusqu\'à 5 photos (gratuit).',
      customerStep2: 'Recevez jusqu\'à 3 offres',
      customerStep2Detail: ' d\'entreprises à proximité.',
      customerStep3: 'Choisissez l\'entreprise',
      customerStep3Detail: ' que vous préférez.',
      customerStep4: 'Tout est gratuit',
      customerStep4Detail: ' pour vous.',
      iAmCustomer: 'Je suis un Client',
      forCompanies: 'Pour les Entreprises',
      companyStep1: 'Parcourir les demandes',
      companyStep1Detail: ' dans votre région et envoyer une offre.',
      companyStep2: 'Contacter le client',
      companyStep2Detail: ' lorsque vous êtes choisi: chat directe et gratuite.',
      companyStep3: 'Abonnement simple',
      companyStep3Detail: ': 49 CHF/mois après 3 mois gratuits.',
      iAmCompany: 'Je suis une Entreprise',
    },

    // Company Requests / Open Requests
    companyRequests: {
      title: 'Demandes Ouvertes',
      filterDistrict: 'District',
      allDistricts: 'Tous les districts',
      filterCategory: 'Catégorie',
      applyFilters: 'Filtrer',
      offersCount: 'offres',
      viewButton: 'Voir',
      sendOfferButton: 'Envoyer l\'offre',
      noRequests: 'Aucune demande ouverte',
      today: 'aujourd\'hui',
      day: 'jour',
      days: 'jours',
      week: 'semaine',
      weeks: 'semaines',
      offerDialogTitle: 'Remplir l\'offre',
      offerType: 'Type d\'offre',
      offerTypeFixed: 'Prix forfaitaire',
      offerTypeHourly: 'À l\'heure',
      fixedAmount: 'Montant forfaitaire (EUR)',
      fixedAmountPlaceholder: 'Ex. 1200',
      hourlyRate: 'Tarif horaire (EUR/heure)',
      hourlyRatePlaceholder: 'Ex. 80',
      numberOfWorkers: 'Nombre d\'ouvriers',
      workersPlaceholder: 'Ex. 2',
      estimatedHours: 'Heures estimées',
      hoursPlaceholder: 'Ex. 6',
      travelCost: 'Frais de déplacement (EUR)',
      travelPlaceholder: 'Ex. 30',
      materialsCost: 'Coût des matériaux (EUR)',
      materialsPlaceholder: 'Ex. 100 (peut être zéro)',
      otherCosts: 'Autres coûts (EUR)',
      otherCostsPlaceholder: 'Ex. élimination, pièces détachées...',
      attachPhotos: 'Joindre des photos (max 3)',
      chooseFiles: 'Choisir des fichiers',
      filesSelected: 'sélectionné(s)',
      availablePeriod: 'Période disponible',
      fromDate: 'Du',
      toDate: 'Au',
      notesOrDetails: 'Notes ou demandes de détails',
      notesPlaceholder: 'Écrivez d\'éventuelles questions ou détails...',
      termsAndConditions: 'Conditions générales',
      termsPlaceholder: 'Spécifier les conditions de paiement, délais, exclusions, etc.',
      total: 'Total',
      send: 'Envoyer',
      invalidAmount: 'Montant total invalide',
      offerSentSuccess: 'Offre envoyée avec succès ✅',
      offerSentError: 'Erreur lors de l\'envoi de l\'offre',
      requestDetailTitle: 'Détails de la demande',
      urgency: 'Urgence',
      yes: 'Oui',
      no: 'Non',
      preferredDays: 'Jours préférés',
      timeSlots: 'Créneaux horaires',
      noPreference: 'Aucune préférence',
    },

    // Settings
    settings: {
      title: 'Paramètres',
      subtitle: 'Gérez vos données personnelles et préférences',
      myData: 'Mes données',
      name: 'Prénom',
      surname: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      address: 'Adresse',
      street: 'Rue',
      number: 'Numéro',
      cap: 'Code postal',
      city: 'Ville',
      cancel: 'Annuler',
      save: 'Enregistrer',
      termsAndConditions: 'Conditions Générales',
      privacyPolicy: 'Politique de Confidentialité',
      needHelp: 'Besoin d\'aide?',
      deleteAccount: 'Supprimer le compte',
      changeProfileImage: 'Changer la photo de profil',
      clientSince: 'Client depuis',
      companySince: 'Entreprise depuis',
      dataUpdated: 'Données mises à jour',
      updateError: 'Erreur de mise à jour',
      invalidImage: 'Sélectionnez une image valide',
      imageTooLarge: 'Image trop volumineuse (max 5MB)',
      profileImageUpdated: 'Photo de profil mise à jour',
      imageUpdateError: 'Erreur de mise à jour de l\'image',
      imageLoadError: 'Erreur de chargement de l\'image',
      deleteAccountTitle: 'Supprimer le compte',
      deleteAccountMessage: 'Faites-nous savoir pourquoi vous partez, nous sommes désolés et aimerions vous aider.',
      deleteReasonPlaceholder: 'Écrivez votre raison ici...',
      evaluateSolution: 'Trouvons une solution ensemble',
      confirmDeleteAccount: 'Supprimer définitivement le compte',
      requestSent: 'Demande envoyée au support',
      understood: 'Compris',
      lastUpdate: 'Dernière mise à jour',
    },

    // Company Settings
    companySettings: {
      companyData: 'Données de l\'Entreprise',
      companyName: 'Nom de l\'Entreprise',
      dangerWarning: 'Attention: cette action est irréversible. Toutes vos données seront définitivement supprimées.',
    },

    // Categories (Artisan professions)
    categories: {
      'Idraulico': 'Plombier',
      'Elettricista': 'Électricien',
      'Pulizie': 'Nettoyage',
      'Giardinaggio': 'Jardinage',
      'Traslochi': 'Déménagement',
      'Falegnameria': 'Menuiserie',
      'Imbianchino/Pittore': 'Peintre/Décorateur',
      'Pavimenti e Piastrelle': 'Sols et Carrelage',
      'Serramenti e Infissi': 'Fenêtres et Portes',
      'Fabbro': 'Serrurier',
      'Riscaldamento e Climatizzazione': 'Chauffage et Climatisation',
      'Antennista': 'Installateur d\'Antennes',
      'Muratore/Edilizia': 'Maçon/Construction',
      'Cartongesso': 'Cloisons Sèches',
      'Tetti e Coperture': 'Toitures et Couvertures',
      'Isolamento Termico': 'Isolation Thermique',
      'Tapparelle e Avvolgibili': 'Volets Roulants',
      'Vetrai': 'Vitrier',
      'Parquet': 'Parquet',
      'Porte e Finestre': 'Portes et Fenêtres',
      'Cancelli Automatici': 'Portails Automatiques',
      'Carpenteria Metallica': 'Charpenterie Métallique',
      'Lattoniere': 'Ferblantier',
      'Spazzacamino': 'Ramoneur',
      'Tende e Zanzariere': 'Rideaux et Moustiquaires',
      'Manutenzione Giardini': 'Entretien de Jardins',
      'Potature': 'Élagage',
      'Allarmi e Videosorveglianza': 'Alarmes et Vidéosurveillance',
      'Domotica': 'Domotique',
      'Fotovoltaico': 'Panneaux Solaires',
      'Caldaie e Stufe': 'Chaudières et Poêles',
      'Pompe di Calore': 'Pompes à Chaleur',
      'Piscine': 'Piscines',
      'Pozzi e Trivellazioni': 'Puits et Forages',
      'Disinfestazione': 'Désinsectisation',
      'Sgomberi': 'Débarras',
      'Ristrutturazioni Complete': 'Rénovations Complètes',
      'Interior Design': 'Design d\'Intérieur',
      'Architetto': 'Architecte',
      'Geometra': 'Géomètre',
      'Ingegnere': 'Ingénieur',
      'Consulente Energetico': 'Consultant Énergétique',
      'Ascensori e Montacarichi': 'Ascenseurs et Monte-charges',
      'Tapezziere': 'Tapissier',
      'Verniciatura Industriale': 'Peinture Industrielle',
      'Lucidatura Pavimenti': 'Polissage de Sols',
      'Trattamento Marmo': 'Traitement du Marbre',
      'Impermeabilizzazioni': 'Étanchéité',
      'Rifacimento Bagno': 'Rénovation Salle de Bain',
      'Rifacimento Cucina': 'Rénovation Cuisine',
      'Cabine Armadio': 'Dressings',
      'Pergole e Gazebo': 'Pergolas et Gazebos',
      'Recinzioni': 'Clôtures',
      'Sistemi di Irrigazione': 'Systèmes d\'Irrigation',
      'Potatura Alberi': 'Élagage',
      'Progettazione Giardini': 'Conception de Jardins',
    },

    // Subscription
    subscription: {
      title: 'Abonnement',
      manage: 'Gérer',
      cancelSubscription: 'Annuler l\'abonnement',
      activateSubscription: 'Activer l\'abonnement',
      subscriptionActive: 'Abonnement Actif',
      subscriptionCanceled: 'Abonnement Annulé',
      perMonth: 'par mois',
      currentMonthSummary: 'Résumé du mois en cours',
      baseSubscription: 'Abonnement de base',
      unlockedContacts: 'Chats activés',
      estimatedTotal: 'Total estimé',
      all: 'Tous',
      enterPassword: 'Entrer le mot de passe',
    },

    // Dashboard
    dashboard: {
      title: 'Tableau de bord',
      summary: 'Aperçu de vos activités',
      requestsMade: 'Demandes Effectuées',
      requestsMadeSubtitle: 'Voir toutes vos demandes de service',
      offersReceived: 'Offres Reçues',
      offersReceivedSubtitle: 'Vérifier les offres des professionnels',
      reviewsMade: 'Avis Donnés',
      reviewsMadeSubtitle: 'Vos évaluations pour les services reçus',
      offersPending: 'En attente',
      offersAccepted: 'Sélectionnées',
      offersRejected: 'Refusées',
      reviewsSummary: 'Résumé des avis',
      basedOnReviews: 'Basé sur {{count}} avis',
      currentMonthBilling: 'Facturation du mois en cours',
      subscription: 'Abonnement',
      contactsUnlocked: 'Contacts Débloqués',
      seeAll: 'Voir tout',
      offersSent: 'Offres Envoyées',
      viewAllOffers: 'Voir toutes vos offres',
      offerStatus: 'Statut de l\'offre',
      withdrawOffer: 'Retirer l\'offre',
      offerWithdrawn: 'Offre retirée',
      cannotWithdraw: 'Impossible de retirer',
      company: 'Entreprise',
    },

    // UI Common
    ui: {
      usefulLinks: 'Liens utiles',
      alreadyHaveAccount: 'Vous avez déjà un compte?',
      login: 'Connexion',
      logout: 'Déconnexion',
      loading: 'Chargement...',
      manageCompanyProfile: 'Gérer le profil de votre entreprise',
      howToBeContacted: 'Comment souhaitez-vous être contacté?',
      companiesWillContact: 'Les entreprises intéressées vous contacteront directement via ce moyen',
      describeYourNeed: 'Décrivez ce dont vous avez besoin et vous serez contacté directement',
      requestPublished: 'Votre demande a été publiée.',
      willBeContacted: 'Vous serez contacté directement par les entreprises intéressées.',
      whatsapp: 'WhatsApp',
      phone: 'Téléphone',
      email: 'E-mail',
      yourEmail: 'Votre e-mail',
      yourNumber: 'Votre numéro (ex. +41 79 123 4567)',
      enterContact: 'Saisissez un moyen de contact',
      monthlyPlan: 'Plan Mensuel',
      freeMonth: '3 mois gratuits',
      firstMonthFree: '3 mois gratuits, puis 49 CHF/mois',
      threeMonthsFree: '3 mois gratuits',
      threeMonthsFreeThen: '3 mois gratuits, puis 49 CHF/mois',
      companyData: 'Données de l\'entreprise',
      yourDataGdpr: 'Vos données (RGPD)',
      downloadAllData: 'Téléchargez toutes vos données personnelles au format JSON.',
      exportMyData: 'Exporter mes données',
      dataExported: 'Données exportées avec succès!',
      dataExportError: 'Erreur lors de l\'export des données',
      invoices: 'Factures',
      allFilter: 'Tous',
      subscriptionFilter: 'Abonnement',
      contactFilter: 'Contact',
      noInvoices: 'Aucune facture',
      invoiceWillBeGenerated: 'La facture sera générée automatiquement le 1er du mois prochain',
      cancelSubscription: 'Annuler l\'abonnement',
      cancelConfirm: 'Êtes-vous sûr de vouloir annuler l\'abonnement?',
      cancel: 'Annuler',
      yesImSure: 'Oui, je suis sûr',
      enterPasswordToConfirm: 'Entrez votre mot de passe pour confirmer.',
      back: 'Retour',
      confirm: 'Confirmer',
      offersReceived: 'Offres reçues',
      backToRequests: 'Retour aux demandes',
      offerDetail: 'Détail de l\'offre',
      amount: 'Montant',
      status: 'Statut',
      pending: 'En attente',
      accepted: 'Acceptée',
      rejected: 'Refusée',
      type: 'Type:',
      fixedPrice: 'Prix forfaitaire',
      hourly: 'Horaire',
      price: 'Prix:',
      hourlyRate: 'Taux horaire:',
      notes: 'Notes:',
      sentDate: 'Date d\'envoi',
      chooseThisCompany: 'Choisir cette entreprise',
      close: 'Fermer',
      noOffers: 'Aucune offre pour le moment.',
      waiting: 'En attente',
      inProgress: 'En cours',
      completed: 'Terminée',
      canceled: 'Annulée',
      openChatWithCompany: 'Ouvrir le chat avec l\'entreprise',
      noCompanySelected: 'Aucune entreprise sélectionnée',
      companySelected: 'Entreprise sélectionnée!',
      selectionError: 'Erreur de sélection',
      emailSent: 'E-mail envoyé!',
      requestNewLink: 'Demander un nouveau lien',
      linkExpiredOrInvalid: 'Le lien a peut-être expiré ou est invalide.',
      nowLoginWithNewPassword: 'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
      passwordMinLength: 'Le mot de passe doit contenir au moins 6 caractères',
      passwordsDontMatch: 'Les mots de passe ne correspondent pas',
      noBinding: 'Sans engagement',
      chooseCompany: 'Choisir l\'entreprise',
      subscriptionInvoice: 'Facture d\'abonnement',
      contactUnlocked: 'Contact débloqué',
    },
  },
};

export const languages = [
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
];
